import React, { Component } from "react";

import "./Header.css";

import configData from "../config.json";

import { toast } from "react-toastify";

import CryptoJS from "crypto-js";

import { Image, Dropdown, Row, Col } from "react-bootstrap";

import Apnapolicy from "./Img/Apnapolicy.png";

import IconIMG from "./Img/IconIMG.jpg";

import { BrowserRouter, Link, Routes, Route } from "react-router-dom";

import MasterTable from "../Sidebar/MasterTable";

import Templates from "../Sidebar/Templates";

import APIPage from "../Sidebar/APIPage";

import DashboardCharts from "../Sidebar/Dashboardcharts";

import RulePage from "../Sidebar/RulePage";

import DashBoard from "../Sidebar/DashBoard";

import { LogOut } from "./LoginComponent";

import Users from "../Sidebar/Users";

import Companies from "../Sidebar/Companies";

import Customers from "../Sidebar/Customers";

import InsuranceTypes from "../Sidebar/InsuranceTypes";

import Settings from "../Sidebar/Settings";

import Zones from "../Sidebar/Zones";

import Agebands from "../Sidebar/Agebands";

import Familydefinitions from "../Sidebar/Familydefinitions";

import Relationships from "../Sidebar/Relationships";

import Plantypes from "../Sidebar/Plantypes";

import Zipcodes from "../Sidebar/Zipcodes";

import Profile from "../Sidebar/Profile";

import Draftpolicies from "../Sidebar/Draftpolicies";

import Sourcepolicies from "../Sidebar/Sourcepolicies";

import Roles from "../Sidebar/Roles";

import Gender from "../Sidebar/Gender";

import InsuranceCategories from "../Sidebar/InsuranceCategories";

import Employeetype from "../Sidebar/Employeetype";

import Departments from "../Sidebar/Departments";

import Designations from "../Sidebar/Designations";

import Leavetypes from "../Sidebar/Leavetypes";

import Holidayslist from "../Sidebar/Holidayslist";

import Offices from "../Sidebar/Offices";

import Irdainsurancecategories from "../Sidebar/Irdainsurancecategories";

import Roleitems from "../Sidebar/Roleitems";

import Workdesk from "../Sidebar/Workdesk";

import Employees from "../Sidebar/Employees";

import Leaverequestapprovals from "../Sidebar/Leaverequestapprovals";

import Lifeinsurancecompanies from "../Sidebar/Lifeinsurancecompanies";

import Nonlifeinsurancecompanies from "../Sidebar/Nonlifeinsurancecompanies";

import Liferidersinsurancecompanies from "../Sidebar/Liferidersinsurancecompanies";

import Irdainsurancetypesnonlife from "../Sidebar/Irdainsurancetypesnonlife";

import Irdainsurancetypeliferiders from "../Sidebar/Irdainsurancetypeliferiders";

import Irdainsurancetypeslife from "../Sidebar/Irdainsurancetypeslife";

import Plantypelinkedunlinked from "../Sidebar/Plantypelinkedunlinked";

import Commissionmasternonlife from "../Sidebar/Commissionmasternonlife";

import Bookedpoliciesnonlife from "../Sidebar/Bookedpoliciesnonlife";

import AttendancePage from "../Sidebar/AttendancePage";

import Chihealthplansintegrated from "../Sidebar/Chihealthplansintegrated";

import Caresupremeaddons from "../Sidebar/Caresupremeaddons";

import Covertype from "../Sidebar/Covertype";

import Caresupremesuminsuredcodes from "../Sidebar/Caresupremesuminsuredcodes";

import Caresupremerelationcodes from "../Sidebar/Caresupremerelationcodes";

import Caresuprememedicalqns from "../Sidebar/Caresuprememedicalqns";

import PoliciesFormPage from "../Sidebar/PoliciesFormPage";

import PoliciesFormFillingPage from "../Sidebar/PoliciesFormFillingPage";

import PoliciesPage from "../Sidebar/PoliciesPage";

import PoliciesComparePage from "../Sidebar/PoliciesComparePage";

import PoliciesKYCForm from "../Sidebar/PoliciesKYCForm";

import PoliciesPagepdf from "../Sidebar/PoliciesPagepdf";

import Proposalsummary from "../Sidebar/Proposalsummary";

import NomineeDetails from "../Sidebar/PlanB/NomineeDetails";

import Medicals from "../Sidebar/PlanB/Medicals";

import Memberinfo from "../Sidebar/PlanB/Memberinfo";

import Proposerinfo from "../Sidebar/PlanB/Proposerinfo";

import AddOns from "../Sidebar/PlanB/AddOns";

import Payments from "../Sidebar/PlanB/Buy";

import Healthcodemasterone from "../Sidebar/Healthcodemasterone";

import Healthproductsfeatures from "../Sidebar/Healthproductsfeatures";

import Healthpincodesmasters from "../Sidebar/Healthpincodesmasters";

import Healthaddonexclusive from "../Sidebar/Healthaddonexclusive";

import Healthageaddons from "../Sidebar/Healthageaddons";

import Healthproducts from "../Sidebar/Healthproducts";

import Healthpins from "../Sidebar/Healthpins";

import Healthagebands from "../Sidebar/Healthagebands";

import Healthfamilydef from "../Sidebar/Healthfamilydef";

import Healthsicodes from "../Sidebar/Healthsicodes";

import PoliciesStatus from "../Sidebar/PoliciesStatus";

import Healthrelationcodes from "../Sidebar/Healthrelationcodes";

import Healthpinaddons from "../Sidebar/Healthpinaddons";

import Healthoccupations from "../Sidebar/Healthoccupations";

import Healthcovertypes from "../Sidebar/Healthcovertypes";

import Healthplantype from "../Sidebar/Healthplantype";

import Healthmaritalstatus from "../Sidebar/Healthmaritalstatus";

import Healthnationality from "../Sidebar/Healthnationality";

import Healthnomineerelations from "../Sidebar/Healthnomineerelations";

import Healthbusinesstype from "../Sidebar/Healthbusinesstype";

import Healthclienttypes from "../Sidebar/Healthclienttypes";

import Healthexternalsystem from "../Sidebar/Healthexternalsystem";

import Healthsiaddons from "../Sidebar/Healthsiaddons";

import Irdaproductname from "../Sidebar/Irdaproductname";

import Healthreliancepins from "../Sidebar/Healthreliancepins";

import Godigithealthpinmaster from "../Sidebar/Godigithealthpinmaster";

import Premiumapprovalentry from "../Sidebar/Premiumapprovalentry";

import Icicihealthpincodes from "../Sidebar/Icicihealthpincodes";

import GoAddOns from "../Sidebar/Godigit/GoAddOns";

import GoMedicals from "../Sidebar/Godigit/GoMedicals";

import GoProposerinfo from "../Sidebar/Godigit/GoProposerinfo";

import GoNomineeDetails from "../Sidebar/Godigit/GoNomineeDetails";

import GoMemberinfo from "../Sidebar/Godigit/GoMemberinfo";

import RGIAddOns from "../Sidebar/RelianceGeneral/RGIAddOns";

import RGIBuy from "../Sidebar/RelianceGeneral/RGIBuy";

import RGIProposerinfo from "../Sidebar/RelianceGeneral/RGIProposerinfo";

import RGINomineeDetails from "../Sidebar/RelianceGeneral/RGINomineeDetails";

import RGIMemberinfo from "../Sidebar/RelianceGeneral/RGIMemberinfo";

import RGIProposalsummary from "../Sidebar/RelianceGeneral/RGIProposalsummary";

import RGIPoliciesThankspage from "../Sidebar/RelianceGeneral/RGIPoliciesThankspage";

import RGIPoliciesKYC from "../Sidebar/RelianceGeneral/RGIPoliciesKYC";

import RGIMedicals from "../Sidebar/RelianceGeneral/RGIMedicals";

import GoPolicySummaryPage from "../Sidebar/Godigit/GoPolicySummaryPage";

import EmployeesProfile from "../Sidebar/EmployeesProfile";

import GoPolicyKycPage from "../Sidebar/Godigit/GoPolicyKycPage";

import GoPolicyThanksPage from "../Sidebar/Godigit/GoPolicyThanksPage";

import PossscOne from "../Sidebar/Possystem/PossscOne";

import PossscOnep from "../Sidebar/Possystem/PossscOnep";

import PosscTwo from "../Sidebar/Possystem/PosscTwo";

import Possctwp from "../Sidebar/Possystem/Possctwp";

import PosscThree from "../Sidebar/Possystem/PosscThree";

import PospE from "../Sidebar/Possystem/PospE";

import Posscthres from "../Sidebar/Possystem/Posscthres";

import PremiumRegisterEntry from "../Sidebar/PremiumRegisterEntry";

import PremiumRegisterVerification from "../Sidebar/PremiumRegisterVerification";

import PremiumRegisterApproval from "../Sidebar/PremiumRegisterApproval";

import ICICIPoliciesKYCPage from "../Sidebar/ICICI/ICICIPoliciesKYCPage";

import ICICIProposeiinfo from "../Sidebar/ICICI/ICICIProposeiinfo";

import ICICIMemberinfo from "../Sidebar/ICICI/ICICIMemberinfo";

import ICICIMedicals from "../Sidebar/ICICI/ICICIMedicals";

import ICICINomineeDetails from "../Sidebar/ICICI/ICICINomineeDetails";

import ICICIAddons from "../Sidebar/ICICI/ICICIAddons";

import ICICIProposalsummary from "../Sidebar/ICICI/ICICIProposalsummary";

import Itsupporttickets from "../Sidebar/Tickets/Itsupporttickets";

import Itsupportticketscreate from "../Sidebar/Tickets/Itsupportticketscreate";

import Itsupportticketsverify from "../Sidebar/Tickets/Itsupportticketsverify";

import Requesttypemaster from "../Sidebar/Tickets/Requesttypemaster";

import Codedeployment from "../Sidebar/Codedeployment/Codedeployment";

import CodeDeployVerfication from "../Sidebar/Codedeployment/CodeDeployverfication";

import ICICIThanksPage from "../Sidebar/ICICI/ICICIThanksPage";

import Posp from "../Sidebar/Possystem/Posp";

import Pospprofile from "../Sidebar/Possystem/Pospprofile";

import EmployeesProfiles from "../Sidebar/EmployeesProfiles";

import EmployeesAttendance from "../Sidebar/EmployeesAttandance/EmployeesAttandance";

import BulkQuote from "../Sidebar/BulkQuotes/BulkQuote";

import ChartWidget from "../Sidebar/Chart/Charts";

import BulkQuoteDetails from "../Sidebar/BulkQuotes/BulkQuoteDetails";

import BulkQuoteFileupload from "../Sidebar/BulkQuotes/BulkQuoteFileupload";

import Charttypemaster from "../Sidebar/Charttypemaster";

import Widgetslibrary from "../Sidebar/Widgetslibrary";

import Widgetsrightstable from "../Sidebar/Widgetsrightstable";

import Peddeclarationdetails from "../Sidebar/Peddeclarationdetails";

import PedDeclarationForm from "../Sidebar/PED/PedDeclarationForm";

import Widgetdashboard from "../Sidebar/Widgetdashboard";

import Drilldown from "../Sidebar/Drilldown";

import Userwidgetactivitylog from "../Sidebar/Userwidgetactivitylog";

import Widgetdefinition from "../Sidebar/Widgetdefinition";

import Integrationlibrary from "../Sidebar/Integrationlibrary";

import Altertable from "../Sidebar/Altertable/Altertable";

import Integrationtypemasters from "../Sidebar/Integrationtypemasters";

import Requestjson from "../Sidebar/Requestjson";

import Responsejson from "../Sidebar/Responsejson";

import Requeststatus from "../Sidebar/Requeststatus";

import Authenticationmethod from "../Sidebar/Authenticationmethod";
import Apnapolicysubscribe from "../Sidebar/Apnapolicysubscribe";
import Rulegroups from "../Sidebar/Rulegroups";
import Rulesdef from "../Sidebar/Rulesdef";
import Actiontypes from "../Sidebar/Actiontypes";
import Ruleactions from "../Sidebar/Ruleactions";
import Ruleflows from "../Sidebar/Ruleflows";
import Ruleflowsteps from "../Sidebar/Ruleflowsteps";
import Apiendpoint from "../Sidebar/Apiendpoint";
import Emailtemplates from "../Sidebar/Emailtemplates";
import Smstemplates from "../Sidebar/Smstemplates";
import Ruleexecutionhistory from "../Sidebar/Ruleexecutionhistory";
import Actionexecutionhistory from "../Sidebar/Actionexecutionhistory";
import Ruleconditions from "../Sidebar/Ruleconditions";
import Externalencryptions from "../Sidebar/Externalencryptions";
import Ruletesttable from "../Sidebar/Ruletesttable";
import Countriesstatescity from "../Sidebar/Countriesstatescity";
import Officeslist from "../Sidebar/Officeslist";
import Checklistsmaster from "../Sidebar/Checklistsmaster";
import Organizations from "../Sidebar/Organizations";
import Policy from "../Sidebar/Policy";
import Member from "../Sidebar/Member";
import Accountdetails from "../Sidebar/Accountdetails";
import Ped from "../Sidebar/Ped";
import Leadopportunity from "../Sidebar/Leadopportunity";
import Address from "../Sidebar/Address";
import Transactionstable from "../Sidebar/Transactionstable";
import Events from "../Sidebar/Events";
import Meetings from "../Sidebar/Meetings";
import Attendees from "../Sidebar/Attendees";
import Claims from "../Sidebar/Claims";
import Termsheets from "../Sidebar/Termsheets";
import Coveragecategory from "../Sidebar/Coveragecategory";
import Coverages from "../Sidebar/Coverages";
import Termsheetcoverage from "../Sidebar/Termsheetcoverage";
import Contact from "../Sidebar/Contact";
import Hospital from "../Sidebar/Hospital";
import Bill from "../Sidebar/Bill";
import Leadstages from "../Sidebar/Leadstages";
import SampleJSONrequest from "../Sidebar/SampleJSONrequest";
import IntegrationLibrarynew from "../Sidebar/IntegrationLibrarynew";
import Test from "../Sidebar/Chart/Test";
import MProposelsummary from "../Sidebar/MotorScreen/MProposelsummary";
import McustomerDetails from "../Sidebar/MotorScreen/McustomerDetails";
import MQuotes from "../Sidebar/MotorScreen/MQuotes";
import MVechileInfo from "../Sidebar/MotorScreen/MVechileInfo";
import Abhalogin from "../Sidebar/ABHA/Abhalogin";
import ConsentCollectionAadhaar from "../Sidebar/ABHA/ConsentCollectionAadhaar";
import AadharAuthentication from "../Sidebar/ABHA/AadharAuthentication";
import ProfileAbhaCollection from "../Sidebar/ABHA/ProfileAbhaCollection";
import AbhaAddressCreation from "../Sidebar/ABHA/AbhaAddressCreation";
import Abharegister from "../Sidebar/ABHA/Abharegister";
import ABHAProfile from "../Sidebar/ABHA/AbhaProfile";
import UpdateProfile from "../Sidebar/ABHA/UpdateProfile";
import KYCreverification from "../Sidebar/ABHA/KYCreverification";
import Rekysuccuess from "../Sidebar/ABHA/Rekysuccuess";
import AdminDragDrop from "../Sidebar/Drag_Drop/AdminDragDrop";

import Pipelines from "../Sidebar/Pipelines";

import Dummyexample from "../Sidebar/Dummyexample";
import Testtable from "../Sidebar/Testtable";
import Abhadetails from "../Sidebar/Abhadetails";
import Itprojectstable from "../Sidebar/Itprojectstable";
import Userstoriestable from "../Sidebar/Userstoriestable";
import Ittaskstable from "../Sidebar/Ittaskstable";
import Taskmovementhistorytable from "../Sidebar/Taskmovementhistorytable";
import Checklistidtable from "../Sidebar/Checklistidtable";
import CommunicationDetails from "../Sidebar/ABHA/CommunicationDetails";
import Tasknotes from "../Sidebar/Tasknotes";
import Tasktypemaster from "../Sidebar/Tasktypemaster";
import MobileOtp from "../Sidebar/ABHA/MobileOtp";
import AbhaVerification from "../Sidebar/ABHA/AbhaVerification";
import ExistingAbha from "../Sidebar/ABHA/ExistingAbha";
import AbhaAddressChange from "../Sidebar/ABHA/AbhaAddressChange";
import Abhaaddressverfication from "../Sidebar/ABHA/Abhaaddressverfication";
import Mckyc from "../Sidebar/MotorScreen/Mckyc";
import Mpolicydownload from "../Sidebar/MotorScreen/Mpolicydownload";
import Motorquotes from "../Sidebar/MotorScreen/Motorquotes";
import Zunopolicyformpage from "../Sidebar/ZUNO/Zunopolicyformpage";
import ZunoProposerinfo from "../Sidebar/ZUNO/ZunoProposerinfo";
import ZunoMemberinfo from "../Sidebar/ZUNO/ZunoMemberinfo";
import ZunoMedical from "../Sidebar/ZUNO/ZunoMedical";
import ZunoAddons from "../Sidebar/ZUNO/ZunoAddons";
import ZunoNominee from "../Sidebar/ZUNO/ZunoNominee";
import ZunoKycpage from "../Sidebar/ZUNO/ZunoKycpage";
import ZunoProposalsummary from "../Sidebar/ZUNO/ZunoProposalsummary";
import ZunoQuotes from "../Sidebar/ZUNO/ZunoQuotes";
import ZunoPolicydownload from "../Sidebar/ZUNO/ZunoPolicydownload";
import ArchiveDragData from "../Sidebar/Drag_Drop/ArchiveDragData";
import Sampletesttable from "../Sidebar/Sampletesttable";
import Testcasetypemaster from "../Sidebar/Testcasetypemaster";
import Testcaseprioritymaster from "../Sidebar/Testcaseprioritymaster";
import Testcasestatusmaster from "../Sidebar/Testcasestatusmaster";
import Environmentmaster from "../Sidebar/Environmentmaster";
import Mobilenumberotp from "../Sidebar/ABHA/Mobilenumberotp";
import Mobileabhaprofile from "../Sidebar/ABHA/Mobileabhaprofile";
import MobileAuthentication from "../Sidebar/ABHA/MobileAuthentication";
import Ittaskstestcaseshistory from "../Sidebar/Ittaskstestcaseshistory";
import Yes_no from "../Sidebar/Yes_no";
import Chatbotconversations from "../Sidebar/Chatbotconversations";
import Trigger_event_type_master from "../Sidebar/Trigger_event_type_master";
import Attachmenttypemaster from "../Sidebar/Attachmenttypemaster";
import Ittaskstestcasesattachments from "../Sidebar/Ittaskstestcasesattachments";
import Table_rule_triggers from "../Sidebar/Table_rule_triggers";
import Rule_execution_queue from "../Sidebar/Rule_execution_queue";
import Table_metadata from "../Sidebar/Table_metadata";
import Chatbotconfig from "../Sidebar/Chatbotconfig";
import Ittaskstestcases from "../Sidebar/Ittaskstestcases";
import Chatbotmessagetypemaster from "../Sidebar/Chatbotmessagetypemaster";
import Conversations from "../Sidebar/Conversations";
import Chatbotmessages from "../Sidebar/Chatbotmessages";
import Chatbotactiontypemaster from "../Sidebar/Chatbotactiontypemaster";
import Chatbotintents from "../Sidebar/Chatbotintents";
import Chatbotuserfeedback from "../Sidebar/Chatbotuserfeedback";
import Chatbotlearningsource from "../Sidebar/Chatbotlearningsource";
import Chatbotlearning from "../Sidebar/Chatbotlearning";
import Chatbotuserrights from "../Sidebar/Chatbotuserrights";
import Hook_execution_log from "../Sidebar/Hook_execution_log";
import Rule_trigger_config from "../Sidebar/Rule_trigger_config";
import Permissiontypemaster from "../Sidebar/Permissiontypemaster";
import Accessscopetypemaster from "../Sidebar/Accessscopetypemaster";
import Statustypemaster from "../Sidebar/Statustypemaster";
import Role_permissions from "../Sidebar/Role_permissions";
import Permission_modules from "../Sidebar/Permission_modules";
import User_roles from "../Sidebar/User_roles";
import Table_permissions from "../Sidebar/Table_permissions";
import Rbac_audit_log from "../Sidebar/Rbac_audit_log";
import Permission_resources from "../Sidebar/Permission_resources";
import Usercontexttypemaster from "../Sidebar/Usercontexttypemaster";
import Accessleveltypemaster from "../Sidebar/Accessleveltypemaster";
import User_contexts from "../Sidebar/User_contexts";
import Permission_conditions from "../Sidebar/Permission_conditions";
import Deploymentstatus from "../Sidebar/Deploymentstatus";
import Cross_table_lookup_cache from "../Sidebar/Cross_table_lookup_cache";
import Rule_execution_performance from "../Sidebar/Rule_execution_performance";
import Parameter_mapping_templates from "../Sidebar/Parameter_mapping_templates";
import Rule_execution_alerts from "../Sidebar/Rule_execution_alerts";
import Universalsomporater from "../Sidebar/Universalsomporater";
import Universalsompoaddonrater from "../Sidebar/Universalsompoaddonrater";
import Company from "../Sidebar/Company";
import Stagingmemberstable from "../Sidebar/Stagingmemberstable";
import Healthmemberdata from "../Sidebar/Healthmemberdata";
import HealthMemberExport from "../Sidebar/HealthMemberExport";
import Employeestatusmaster from "../Sidebar/Employeestatusmaster";
import Companyhasemployees from "../Sidebar/Companyhasemployees";
import EmployeeFamilyManagement from "../Sidebar/EmployeeFamilyManagement";
import Industrytypemaster from "../Sidebar/Industrytypemaster";
import Bulkimportstatusmaster from "../Sidebar/Bulkimportstatusmaster";
import Bulkimportoperationtypemaster from "../Sidebar/Bulkimportoperationtypemaster";
import Bulkimportoperationstatusmaster from "../Sidebar/Bulkimportoperationstatusmaster";
import Bulkimportruletypemaster from "../Sidebar/Bulkimportruletypemaster";
import Bulkimportprioritymaster from "../Sidebar/Bulkimportprioritymaster";
import Import_sessions from "../Sidebar/Import_sessions";
import Import_field_mappings from "../Sidebar/Import_field_mappings";
import Import_process_logs from "../Sidebar/Import_process_logs";
import Import_validation_rules from "../Sidebar/Import_validation_rules";
import Import_templates from "../Sidebar/Import_templates";
import Import_queue from "../Sidebar/Import_queue";
import BulkImport from "../Sidebar/BulkImport/BulkImport";
import BulkImportWizard from "../Sidebar/BulkImport/BulkImportWizard";
import FieldMappingStep from "../Sidebar/BulkImport/steps/FieldMappingStep";
import FileUploadStep from "../Sidebar/BulkImport/steps/FileUploadStep";
import ProcessingStep from "../Sidebar/BulkImport/steps/ProcessingStep";
import ResultsStep from "../Sidebar/BulkImport/steps/ResultsStep";
import TableSelectionStep from "../Sidebar/BulkImport/steps/TableSelectionStep";
import ValidationStep from "../Sidebar/BulkImport/steps/ValidationStep";
import Tw_uat_master from "../Sidebar/Tw_uat_master";
import Tw_rto_master from "../Sidebar/Tw_rto_master";
import Pincodemaster from "../Sidebar/Pincodemaster";
import Tatainsurancemaster from "../Sidebar/Tatainsurancemaster";
import Tata_mmv_master from "../Sidebar/Tata_mmv_master";
import Tata_finance_master from "../Sidebar/Tata_finance_master";
import Universalsompoproducts from "../Sidebar/Universalsompoproducts";
import Universalsompoaddons from "../Sidebar/Universalsompoaddons";
import Bulkquoteaddonrequest from "../Sidebar/Bulkquoteaddonrequest";
import Bulkquotebasepremiumrequest from "../Sidebar/Bulkquotebasepremiumrequest";
import Universalpincodes from "../Sidebar/Universalpincodes";
import Bulkquotesummary from "../Sidebar/Bulkquotesummary";
import Bulkquoterequest from "../Sidebar/Bulkquoterequest";
import Bulkquoteaddonsummary from "../Sidebar/Bulkquoteaddonsummary";
import Motoraddonstable from "../Sidebar/Motoraddonstable";
import Magmarater from "../Sidebar/Magmarater";
import Magmapincodes from "../Sidebar/Magmapincodes";
import Altertabletesting from "../Sidebar/Altertabletesting";
import Bulkquoteefd from "../Sidebar/Bulkquoteefd";
//  import Dummytable from '../Sidebar/Dummytable';
//  import Testtableoone from '../Sidebar/Testtableoone';
import Testtabletwo from "../Sidebar/Testtabletwo";
import Generatebulkquote from "../Sidebar/Generatebulkquote";
import Zunothankspage from "../Sidebar/ZUNO/Zunothankspage";
import ZunoKycresponse from "../Sidebar/ZUNO/ZunoKycresponse";
import Motorproducts from "../Sidebar/Motorproducts";
import MQuotesaddons from "../Sidebar/MotorScreen/MQuotesaddons";
import Generatesamplepage from "../Sidebar/Generatesamplepage";
import Deals from "../Sidebar/Deals";
import Dailystatusreport from "../Sidebar/Dailystatusreport";
// import ZunoKycresponse from "../Sidebar/ZUNO/ZunoKycresponse";
import Page_layouts from "../Sidebar/Page_layouts";
import Layout_rows from "../Sidebar/Layout_rows";
import Layout_cells from "../Sidebar/Layout_cells";
import Widget_instances from "../Sidebar/Widget_instances";
import Audit_logs from "../Sidebar/Audit_logs";
import Audit_log_config from "../Sidebar/Audit_log_config";
//import Audit_log_config_NEW from "../Sidebar/Audit_log_config_NEW";
import Audit_logs_NEW from "../Sidebar/Audit_logs_NEW";
import Widget_event_bindings_NEW from "../Sidebar/Widget_event_bindings_NEW";
import Widget_instances_NEW from "../Sidebar/Widget_instances_NEW";
import Widget_library_categories_NEW from "../Sidebar/Widget_library_categories_NEW";
import Widget_types_NEW from "../Sidebar/Widget_types_NEW";
import Widgetdashboard_NEW from "../Sidebar/Widgetdashboard_NEW";
import Widgetdefinition_NEW from "../Sidebar/Widgetdefinition_NEW";
import Widgetslibrary_NEW from "../Sidebar/Widgetslibrary_NEW";
import Widgetsrightstable_NEW from "../Sidebar/Widgetsrightstable_NEW";
import Form_field_validations_NEW from "../Sidebar/Form_field_validations_NEW";
import User_preferences_NEW from "../Sidebar/User_preferences_NEW";
import User_dashboard_configs_NEW from "../Sidebar/User_dashboard_configs_NEW";
import Resource_permissions_NEW from "../Sidebar/Resource_permissions_NEW";
import User_feature_flags_NEW from "../Sidebar/User_feature_flags_NEW";
// Widget Framework - Management pages
import Widgetinstancesmanager from "../Sidebar/Widgetinstancesmanager";
import BatchMigration from "../Sidebar/BatchMigration";
import WidgetEventContext from "../widgets/WidgetEventContext";
import Table_form_mapping_NEW from "../Sidebar/Table_form_mapping_NEW";
// import WidgetPageRenderer from "../widgets/WidgetPageRenderer";
// import WidgetRenderer from "../widgets/WidgetRenderer";
import DynamicFormAdapter from "../widgets/adapters/DynamicFormAdapter";
import HighchartsAdapter from "../widgets/adapters/HighchartsAdapter";
import KPICardAdapter from "../widgets/adapters/KPICardAdapter";
import PrimeReactTableAdapter from "../widgets/adapters/PrimeReactTableAdapter";
import ReactDataTableAdapter from "../widgets/adapters/ReactDataTableAdapter";
import SearchFilterAdapter from "../widgets/adapters/SearchFilterAdapter";
import StaticHtmlAdapter from "../widgets/adapters/StaticHtmlAdapter";
import WidgetErrorBoundary from "../widgets/common/WidgetErrorBoundary";
import WidgetLoader from "../widgets/common/WidgetLoader";
import ColumnConfigEditor from "../widgets/editors/ColumnConfigEditor";
import DashboardBuilder from "../widgets/editors/DashboardBuilder";
import FormConfigEditor from "../widgets/editors/FormConfigEditor";
import LayoutEditor from "../widgets/editors/LayoutEditor";
import LayoutPreview from "../widgets/editors/LayoutPreview";
import WidgetInstanceEditor from "../widgets/editors/WidgetInstanceEditor";
import Data_access_rules from "../Sidebar/Data_access_rules";
import Field_access_rules from "../Sidebar/Field_access_rules";
import Hierarchy_cache from "../Sidebar/Hierarchy_cache";
import DealConversations from "../Sidebar/DealConversations";
import Dealmnotes from "../Sidebar/Dealnotes";
import Eventactions from "../Sidebar/Eventactions";
import Event_conditions from "../Sidebar/Event_conditions";
import Event_queue from "../Sidebar/Event_queue";
import Eventtypemaster from "../Sidebar/Eventtypemaster";
import Eventactiontypemaster from "../Sidebar/Eventactiontypemaster";
import Testevents from "../Sidebar/Testevents";
import Deploymentrequests from "../Sidebar/Deploymentrequests";
import Deploymentfiles from "../Sidebar/Deploymentfiles";
import Deploymentdbqueries from "../Sidebar/Deploymentdbqueries";
import Deploymentstatusmaster from "../Sidebar/Deploymentstatusmaster";
import Deploymentapprovals from "../Sidebar/Deploymentapprovals";
import Deploymentrollback from "../Sidebar/Deploymentrollback";
import Deploymentpackages from "../Sidebar/Deploymentpackages";
import Deploymentactiontypemaster from "../Sidebar/Deploymentactiontypemaster";
import ITDashboard from "../Sidebar/ITDashboard";
import ITHomeDashboard from "../Sidebar/ITHomeDashboard";
import Employeetasksummary from "../Sidebar/Employeetasksummary";
import DeploymentRequestpage from "../Sidebar/Drag_Drop/DeploymentRequestpage";
import DeploymentDashboard from "../Sidebar/DeploymentDashboard";
import RepoChanges from "../Sidebar/RepoChanges";
import CrossTeamCheck from "../Sidebar/CrossTeamCheck";
import DeploymentExecutionPage from "../Sidebar/DeploymentExecutionPage";
import LinkedRequestsView from "../Sidebar/LinkedRequestsView";
import NotificationsPanel from "../Sidebar/NotificationsPanel";
import DeploymentConfig from "../Sidebar/DeploymentConfig";
import Emailstatusmaster from "../Sidebar/Emailstatusmaster";
import Triggermaster from "../Sidebar/Triggermaster";
import Tv_tokens from "../Sidebar/Tv_tokens";
import Headersmaster from "../Sidebar/Headersmaster";
import Taskpenalitypoints from "../Sidebar/Taskpenalitypoints"; /* replceimport */

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.inputFileRef = React.createRef();

    this.state = {
      isSidenavOpen: false,

      isSubMenuOpen: false,

      isSubMenuOpenone: false,

      isSubMenuOpentwo: false,

      isSubMenuOpenthree: false,

      isSubMenuOpenfour: false,

      isSubMenuOpenfive: false,

      isSubMenuOpensix: false,

      isDropdownOpen: false,

      isSubMenuOpenseven: false,
      isSubMenuOpensIntegrationWork: false,
      isSubMenuOpeneight: false,
      isSubMenuOpenABHA: false,
      isSubMenuOpenKANBAN: false,

      sId: sessionStorage.getItem("sId"),

      uId: sessionStorage.getItem("uId"),

      pospId: sessionStorage.getItem("pospId"),

      data: [],

      data0: [],

      data1: [],

      data2: [],

      data3: [],

      data4: [],

      data5: [],

      data6: [],

      data7: [],

      data8: [],

      data9: [],

      data10: [],

      data11: [],

      data12: [],

      data13: [],

      data14: [],

      data15: [],

      data16: [],

      count: 0,

      count0: 0,

      count1: 0,

      count2: 0,

      count3: 0,

      count4: 0,

      count5: 0,

      count6: 0,

      count7: 0,

      count8: 0,

      count9: 0,

      count10: 0,

      count11: 0,

      count12: 0,

      count13: 0,

      count14: 0,

      count15: 0,

      count16: 0,

      count17: 0,

      count18: 0,

      count19: 0,
    };
  }
  // Widget Framework: Map of routes to NEW components (feature-flagged)
  // Each route only activates when a per-route feature flag exists in user_feature_flags
  widgetNewComponents = {
    // --- 5 pilot pages (Phase 1-2) ---

    audit_logs: Audit_logs_NEW,
    widget_event_bindings: Widget_event_bindings_NEW,
    widget_instances: Widget_instances_NEW,
    widget_library_categories: Widget_library_categories_NEW,
    widget_types: Widget_types_NEW,
    widgetdashboard: Widgetdashboard_NEW,
    widgetdefinition: Widgetdefinition_NEW,
    widgetslibrary: Widgetslibrary_NEW,
    widgetsrightstable: Widgetsrightstable_NEW,
  };

  /**
   * Resolve which component to render for a route based on feature flags.
   * Only activates when a per-route feature flag exists (created by BatchMigration).
   * The wildcard flag is ignored to prevent activating pages without DB records.
   */
  resolveComponent = (routePath, OldComponent) => {
    const { featureFlags } = this.state;
    if (!featureFlags || featureFlags.length === 0) return OldComponent;

    // Check for route-specific flag (created by BatchMigration for each migrated page)
    const routeFlag = featureFlags.find(
      (f) => f.routePath === routePath && parseInt(f.isEnabled) === 1,
    );

    if (routeFlag) {
      const NewComponent = this.widgetNewComponents[routePath];
      if (NewComponent) return NewComponent;
    }

    return OldComponent;
  };

  /**
   * Helper to render a route with automatic widget framework resolution.
   * Usage: {this.renderRoute("routepath", OldComponent)}
   */
  renderRoute = (routePath, OldComponent) => {
    const C = this.resolveComponent(routePath, OldComponent);
    return <Route path={routePath} element={<C />}></Route>;
  };
  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  // Function to toggle submenu collapse/expand

  toggleSubMenu = () => {
    this.setState((prevState) => ({ isSubMenuOpen: !prevState.isSubMenuOpen }));
  };
  toggleABHAMenu = () => {
    this.setState((prevState) => ({
      isSubMenuOpenABHA: !prevState.isSubMenuOpenABHA,
    }));
  };
  toggleHealthMenu = () => {
    this.setState((prevState) => ({
      isSubMenuOpenHealth: !prevState.isSubMenuOpenHealth,
    }));
  };
  toggleKANBANMenu = () => {
    this.setState((prevState) => ({
      isSubMenuOpenKANBAN: !prevState.isSubMenuOpenKANBAN,
    }));
  };
  toggleSubMenuIT = () => {
    this.setState((prevState) => ({
      isSubMenuOpenIT: !prevState.isSubMenuOpenIT,
    }));
  };

  toggleSubMenuOne = () => {
    this.setState((prevState) => ({
      isSubMenuOpenone: !prevState.isSubMenuOpenone,
    }));
  };

  toggleSubMenuTwo = () => {
    this.setState((prevState) => ({
      isSubMenuOpentwo: !prevState.isSubMenuOpentwo,
    }));
  };

  toggleSubMenuThree = () => {
    this.setState((prevState) => ({
      isSubMenuOpenthree: !prevState.isSubMenuOpenthree,
    }));
  };

  toggleSubMenuFour = () => {
    this.setState((prevState) => ({
      isSubMenuOpenfour: !prevState.isSubMenuOpenfour,
    }));
  };

  toggleSubMenuFive = () => {
    this.setState((prevState) => ({
      isSubMenuOpenfive: !prevState.isSubMenuOpenfive,
    }));
  };

  toggleSubMenuSix = () => {
    this.setState((prevState) => ({
      isSubMenuOpensix: !prevState.isSubMenuOpensix,
    }));
  };

  toggleSubMenuSeven = () => {
    this.setState((prevState) => ({
      isSubMenuOpenseven: !prevState.isSubMenuOpenseven,
    }));
  };
  toggleSubMenuNine = () => {
    this.setState((prevState) => ({
      isSubMenuOpennine: !prevState.isSubMenuOpennine,
    }));
  };
  toggleSubMenuIntegrationWorks = () => {
    this.setState((prevState) => ({
      isSubMenuOpensIntegrationWork: !prevState.isSubMenuOpensIntegrationWork,
    }));
  };

  toggleSubMenuEight = () => {
    this.setState((prevState) => ({
      isSubMenuOpeneight: !prevState.isSubMenuOpeneight,
    }));
  };
  toggleSubMenuTen = () => {
    this.setState((prevState) => ({
      isSubMenuOpenten: !prevState.isSubMenuOpenten,
    }));
  };
  handleToggleSidenav = () => {
    this.setState((prevState) => ({
      isSidenavOpen: !prevState.isSidenavOpen,
    }));
  };
  handlewidgetSidenav = () => {
    this.setState((prevState) => ({
      isSidenavwidgetOpen: !prevState.isSidenavwidgetOpen,
    }));
  };
  handlenoncategSidenav = () => {
    this.setState((prevState) => ({
      isnocategSidenavOpen: !prevState.isnocategSidenavOpen,
    }));
  };

  handleListItemClick = () => {
    this.setState({
      isSidenavOpen: false,
    });
  };

  handleProfileClick = () => {
    window.location.href = "/profile";

    // Replace '/profile' with the actual URL for the profile page
  };

  decryptData = (roleData) => {
    const bytes = CryptoJS.AES.decrypt(roleData, configData.secret);

    const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return data;
  };

  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;

    if (type === "success") tType = toast.TYPE.SUCCESS;

    if (type === "error") tType = toast.TYPE.ERROR;

    if (type === "warning") tType = toast.TYPE.WARNING;

    toast(msg, { type: tType });
  };

  handleretrivedata = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("pospId", this.state.pospId);

    fetch(configData.api_url + "posps/all/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((rsdata) => {
        if (rsdata.status === "success") {
          const list = rsdata.list;

          const data = [];

          const data0 = [];

          const data1 = [];

          const data2 = [];

          const data3 = [];

          const data4 = [];

          list.forEach((element) => {
            if (element.pStatus === "1") {
              data.push(element);
            } else if (element.pStatus === "2") {
              data0.push(element);
            } else if (element.pStatus === "3" || element.pStatus === "5") {
              data1.push(element);
            } else if (element.pStatus === "4") {
              data2.push(element);
            } else if (element.pStatus === "6" || element.pStatus === "8") {
              data3.push(element);
            } else if (element.pStatus === "7") {
              data4.push(element);
            }
          });

          this.setState({
            data0: data0,

            count0: data0.length,

            data: data,

            count: data.length,

            data1: data1,

            count1: data1.length,

            data2: data2,

            count2: data2.length,

            data3: data3,

            count3: data3.length,

            data4: data4,

            count4: data4.length,
          });
        }
      });
  };

  handleMispretrivedata = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("pospId", this.state.pospId);

    fetch(configData.api_url + "misps/all/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((rsdata) => {
        if (rsdata.status === "success") {
          const list = rsdata.list;

          const data5 = [];

          const data6 = [];

          const data7 = [];

          const data8 = [];

          const data9 = [];

          list.forEach((element) => {
            if (element.pStatus === "2") {
              data5.push(element);
            } else if (element.pStatus === "1" || element.pStatus === "2") {
              data6.push(element);
            } else if (element.pStatus === "3" || element.pStatus === "4") {
              data7.push(element);
            } else if (element.pStatus === "4" || element.pStatus === "5") {
              data8.push(element);
            } else if (element.pStatus === "6") {
              data9.push(element);
            }
          });

          this.setState({
            data5: data5,

            count5: data5.length,

            data6: data6,

            count6: data6.length,

            data7: data7,

            count7: data7.length,

            data8: data8,

            count8: data8.length,

            data9: data9,

            count9: data9.length,
          });
        }
      });
  };

  handleItticketretrivedata = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Itsupporttickets/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          const list = data.list;
          const data10 = [];
          list.forEach((element) => {
            if (element.status === "1") {
              data10.push(element);
            }
          });

          this.setState({
            data10: data10,

            count10: data10.length,
          });
        }
      });
  };

  handlecodedeploymentverification = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Codedeployment/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          const list = data.list;

          const data11 = [];

          list.forEach((element) => {
            if (element.status === "1") {
              data11.push(element);
            }
          });

          this.setState({
            data11: data11,

            count11: data11.length,
          });
        }
      });
  };

  handlePremiumregister = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Premiumapprovalentry/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((rsdata) => {
        if (rsdata.status === "success") {
          const list = rsdata.list;

          const data13 = [];

          const data14 = [];

          const data15 = [];

          list.forEach((element) => {
            if (
              element.mStatus === "2" ||
              element.mStatus === "3" ||
              element.mStatus === "7"
            ) {
              data13.push(element);
            } else if (element.mStatus === "5" || element.mStatus === "6") {
              data14.push(element);
            } else if (element.mStatus === "1" || element.mStatus === "4") {
              data15.push(element);
            }
          });

          this.setState({
            data13: data13,

            count13: data13.length,

            data14: data14,

            count14: data14.length,

            data15: data15,

            count15: data15.length,
          });
        }
      });
  };

  componentDidMount() {
    this.handleretrivedata();
    this.handleMispretrivedata();
    this.handleItticketretrivedata();
    this.handlecodedeploymentverification();
    this.handlePremiumregister();
  }

  render() {
    const uName = sessionStorage.getItem("userName");
    const { isSidenavOpen } = this.state;
    const iconStyle = {
      position: "relative",
      display: "inline-block",
      width: "1.5rem",
      height: "1.5rem",
      lineHeight: "1.5rem",
      textAlign: "center",
      borderRadius: "50%",
      backgroundColor: this.state.count > 0 ? "red" : "green",
      color: "white",
    };

    const {
      isSubMenuOpen,
      isSubMenuOpenone,
      isSubMenuOpentwo,
      isSubMenuOpenthree,
      isSubMenuOpenfour,
      isSubMenuOpenfive,
      isSubMenuOpenseven,
      isSubMenuOpeneight,
      isSubMenuOpensIntegrationWork,
      isSubMenuOpenIT,
      isSubMenuOpenABHA,
      isSubMenuOpenKANBAN,
      isSubMenuOpenHealth,
      isSubMenuOpensix,
      isSubMenuOpennine,
      isSubMenuOpenten,
      isSidenavwidgetOpen,
      isnocategSidenavOpen,
    } = this.state;
    const sidenavClassName = isSidenavOpen ? "MobileMenuShow" : "";
    const roledata = JSON.parse(sessionStorage.getItem("roleData"));

    return (
      <div className="nav-fixed">
        <BrowserRouter>
          <nav className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white">
            <button
              onClick={this.handleToggleSidenav}
              id="mobilemenu"
              style={{
                border: "none",
                backgroundColor: "#fff",
              }}
            >
              <span
                className="bi bi-list"
                style={{ color: "#536b9f", fontSize: "20px" }}
              ></span>
            </button>

            <Image
              src={Apnapolicy}
              className="navbar-brand pe-3 ps-4 ps-lg-2"
              alt=""
              style={{ width: "192px", height: "44px" }}
            />

            <ul className="navbar-nav align-items-center ms-auto">
              <li className="nav-item me-2">
                <NotificationsPanel />
              </li>
              <Link to="workdesk" className="nav-link collapsed">
                <i className="bi bi-bell">
                  <div style={{ iconStyle }}>
                    {this.state.count11 + " " + this.state.count11}
                  </div>
                  {/* {this.state.count11} */}
                </i>
              </Link>

              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-custom-components"
                  className="me-3 "
                  style={{ color: "#3ca8e8" }}
                  variant="light"
                >
                  <Image
                    style={{ width: "30px", height: "30px" }}
                    src={IconIMG}
                    alt=""
                  />
                  &nbsp;
                  {uName}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item eventKey="1" onClick={this.handleProfileClick}>
                    Profile
                  </Dropdown.Item>

                  <Dropdown.Item eventKey="2" onClick={LogOut}>
                    Log out &nbsp;
                    <span className="bi bi-box-arrow-right ms-3"></span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </nav>

          <div id="layoutSidenav">
            <div id="layoutSidenav_nav" className={sidenavClassName}>
              <nav className="sidenav sidenav-light shadow-right">
                <div className="sidenav-menu">
                  <div className="row d-flex">
                    <div className=" profile_pic col-4">
                      <Image className="newI" src={IconIMG} alt="" />
                    </div>

                    <div className="profile_info col-8">
                      <span>Welcome</span>

                      <h3>{uName}</h3>
                    </div>
                  </div>

                  <div className="nav accordion" id="accordionSidenav">
                    <ul
                      className="mainsidebarDashboardMenu"
                      style={{
                        fontFamily: "Calibri",
                        fontSize: "15px",
                        color: "red",
                      }}
                    >
                      {roledata.dashboard_view && (
                        <li>
                          <Link to="/dashboard" className="nav-link collapsed">
                            <div className="nav-link-icon">
                              <span className="bi bi-house-door-fill"></span>
                            </div>
                            Dash Board
                          </Link>
                        </li>
                      )}
                      {roledata.motor_view && (
                        <li>
                          <Link
                            to="motorquotes"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Motor Quotes
                          </Link>
                        </li>
                      )}
                      {roledata.deployments_library_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuTen}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Deployments
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpenten
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenten ? "show" : "collapse"
                            }`}
                          >
                            {roledata.deploymentdashboard_view && (
                              <li>
                                <Link
                                  to="deploymentdashboard"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-grid-1x2"></span>
                                  </div>
                                  Deployment Dashboard
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentconfig_view && (
                              <li>
                                <Link
                                  to="deploymentconfig"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-gear-wide-connected"></span>
                                  </div>
                                  Deployment Config
                                </Link>
                              </li>
                            )}
                            {roledata.crossteamcheck_view && (
                              <li>
                                <Link
                                  to="crossteamcheck"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-gear-wide-connected"></span>
                                  </div>
                                  Cross Team Check
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentexecution_view && (
                              <li>
                                <Link
                                  to="deploymentexecution"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-gear-wide-connected"></span>
                                  </div>
                                  Deploy to server
                                </Link>
                              </li>
                            )}
                            {roledata.linkedrequests_view && (
                              <li>
                                <Link
                                  to="linkedrequests"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-link-45deg"></span>
                                  </div>
                                  Linked Requests
                                </Link>
                              </li>
                            )}
                            {roledata.repochanges_view && (
                              <li>
                                <Link
                                  to="repochanges"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-git"></span>
                                  </div>
                                  Repo Changes
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentrequestpage_view && (
                              <li>
                                <Link
                                  to="deploymentrequestpage"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Request Page
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentrequests_view && (
                              <li>
                                <Link
                                  to="deploymentrequests"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Requests
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentfiles_view && (
                              <li>
                                <Link
                                  to="deploymentfiles"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Files
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentdbqueries_view && (
                              <li>
                                <Link
                                  to="deploymentdbqueries"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  DeploymentDbQueries
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentstatusmaster_view && (
                              <li>
                                <Link
                                  to="deploymentstatusmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Status Master
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentapprovals_view && (
                              <li>
                                <Link
                                  to="deploymentapprovals"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Approvals
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentrollback_view && (
                              <li>
                                <Link
                                  to="deploymentrollback"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Rollback
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentpackages_view && (
                              <li>
                                <Link
                                  to="deploymentpackages"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Packages
                                </Link>
                              </li>
                            )}
                            {roledata.deploymentactiontypemaster_view && (
                              <li>
                                <Link
                                  to="deploymentactiontypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Actiontype Master
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.abha_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded 
                            bi bi-pc-display-horizontal"
                            onClick={this.toggleABHAMenu}
                            style={{}}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "14px", paddingLeft: "5px" }}
                            >
                              ABHA
                            </span>
                            <i
                              className={`bi ${
                                isSubMenuOpenABHA
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenABHA ? "show" : "collapse"
                            }`}
                          >
                            {roledata.abha_register_view && (
                              <li>
                                <Link
                                  to="abharegister"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  ABHA Creation
                                </Link>
                              </li>
                            )}

                            {roledata.abha_register_view &&
                              sessionStorage.getItem("abhaProfileStatus") ===
                                "success" && (
                                <li>
                                  <Link
                                    to="abhaverification"
                                    className="nav-link active collapsed"
                                  >
                                    <div className="nav-link-icon">
                                      <span className="bi bi-speedometer2"></span>
                                    </div>
                                    ABHA Verification
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </li>
                      )}
                      {roledata.kanban_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded 
                            bi bi-pc-display-horizontal"
                            onClick={this.toggleKANBANMenu}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;PIPE LINES&nbsp;
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpenKANBAN
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenKANBAN ? "show" : "collapse"
                            }`}
                          >
                            {roledata.abha_register_view && (
                              <li>
                                <Link
                                  to="pipelines"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Pipe lines
                                </Link>
                              </li>
                            )}
                            {roledata.abha_register_view && (
                              <li>
                                <Link
                                  to="admindragdrop"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Admin Drag & Drop
                                </Link>
                              </li>
                            )}
                            {roledata.abha_register_view && (
                              <li>
                                <Link
                                  to="archivedragdata"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Archive Tasks
                                </Link>
                              </li>
                            )}
                            {roledata.itprojectstable_view && (
                              <li>
                                <Link
                                  to="itprojectstable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Projects
                                </Link>
                              </li>
                            )}
                            {roledata.userstoriestable_view && (
                              <li>
                                <Link
                                  to="userstoriestable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  User Stories
                                </Link>
                              </li>
                            )}
                            {roledata.leadstages_view && (
                              <li>
                                <Link
                                  to="leadstages"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Lead Stages
                                </Link>
                              </li>
                            )}
                            {roledata.ittaskstable_view && (
                              <li>
                                <Link
                                  to="ittaskstable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Tasks
                                </Link>
                              </li>
                            )}
                            {roledata.tasknotes_view && (
                              <li>
                                <Link
                                  to="tasknotes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Task Notes
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.tasktypemaster_view && (
                              <li>
                                <Link
                                  to="tasktypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Task Types Master
                                </Link>
                              </li>
                            )}
                            {roledata.taskmovementhistorytable_view && (
                              <li>
                                <Link
                                  to="taskmovementhistorytable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Task Movement History
                                </Link>
                              </li>
                            )}
                            {roledata.checklistidtable_view && (
                              <li>
                                <Link
                                  to="checklistidtable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Check list-Id
                                </Link>
                              </li>
                            )}
                            {roledata.dealconversations_view && (
                              <li>
                                <Link
                                  to="dealconversations"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deal Conversations
                                </Link>
                              </li>
                            )}
                            {roledata.dealnotes_view && (
                              <li>
                                <Link
                                  to="dealnotes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deal notes
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.it_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenu}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;IT&nbsp;
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpen
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpen ? "show" : "collapse"
                            }`}
                          >
                            {roledata.table_creator_view && (
                              <li>
                                <Link
                                  to="/mastertable"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-file-earmark-spreadsheet"></span>
                                  </div>
                                  Table Creator
                                </Link>
                              </li>
                            )}

                            {roledata.alter_table_view && (
                              <li>
                                <Link
                                  to="/altertable"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-file-earmark-spreadsheet"></span>
                                  </div>
                                  Table Alter
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.it_support_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuIT}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;IT Support&nbsp;
                            </span>

                            <i
                              style={{ fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpenIT
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenIT ? "show" : "collapse"
                            }`}
                          >
                            {roledata.itsupportticketscreate_view && (
                              <li>
                                <Link
                                  to="itsupportticketscreate"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div>Create Ticket</div>
                                </Link>
                              </li>
                            )}

                            {roledata.itsupportticketsverify_view && (
                              <li>
                                <Link
                                  to="itsupportticketsverify"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Verify&nbsp;Ticket
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px ",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count10}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.requesttypemaster_view && (
                              <li>
                                <Link
                                  to="requesttypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Request Type Master
                                </Link>
                              </li>
                            )}

                            {roledata.itsupporttickets_view && (
                              <li>
                                <Link
                                  to="itsupporttickets"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Support Tickets
                                </Link>
                              </li>
                            )}

                            {roledata.codedeployment_view && (
                              <li>
                                <Link
                                  to="codedeployment"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Code Deployment
                                </Link>
                              </li>
                            )}

                            {roledata.codeverification_view && (
                              <li>
                                <Link
                                  to="codeverfication"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Code Verification&nbsp;
                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count11}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.charttypemaster_view && (
                              <li>
                                <Link
                                  to="charttypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chart Type Master
                                </Link>
                              </li>
                            )}

                            {roledata.peddeclarationdetails_view && (
                              <li>
                                <Link
                                  to="peddeclarationdetails"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  PED Declaration Details
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.hr_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-people"
                            onClick={this.toggleSubMenuOne}
                          >
                            &nbsp;
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;HR &nbsp;
                            </span>
                            <i
                              style={{ fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpenone
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>
                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenone ? "show" : "collapse"
                            }`}
                          >
                            {roledata.roles_view && (
                              <li>
                                <Link to="roles" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-person-fill-gear"></span>
                                  </div>
                                  Roles
                                </Link>
                              </li>
                            )}

                            {roledata.departments_view && (
                              <li>
                                <Link
                                  to="departments"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Departments
                                </Link>
                              </li>
                            )}

                            {roledata.eAttendance_view && (
                              <li>
                                <Link
                                  to="/empattandance"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-file-earmark-spreadsheet"></span>
                                  </div>
                                  EmployeesAttandance
                                </Link>
                              </li>
                            )}

                            {roledata.designations_view && (
                              <li>
                                <Link
                                  to="designations"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Designations
                                </Link>
                              </li>
                            )}

                            {roledata.employees_view && (
                              <li>
                                <Link
                                  to="employees"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Employees
                                </Link>
                              </li>
                            )}

                            {roledata.offices_view && (
                              <li>
                                <Link
                                  to="offices"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Offices
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.attandance_leaves_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-calendar2-week"
                            onClick={this.toggleSubMenuTwo}
                          >
                            &nbsp;
                            <span
                              className="menu-title "
                              style={{ fontSize: "15px" }}
                            >
                              <Row>
                                <Col lg="12">
                                  &nbsp;Attendance&nbsp;& Leaves
                                </Col>
                              </Row>
                            </span>
                            <i
                              style={{ marginTop: "5px", fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpentwo
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>
                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpentwo ? "show" : "collapse"
                            }`}
                          >
                            {roledata.attendancepage_view && (
                              <li>
                                <Link
                                  to="attendancepage"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Mark&nbsp;Attendance
                                </Link>
                              </li>
                            )}

                            {roledata.leaverequestapprovals_view && (
                              <li>
                                <Link
                                  to="leaverequestapprovals"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Leaves
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.Ped_Details_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuSeven}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;PED&nbsp;
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpenseven
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenseven ? "show" : "collapse"
                            }`}
                          >
                            {roledata.peddeclarationdetails_view && (
                              <li>
                                <Link
                                  to="peddeclarationform"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Ped Declaration Form
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.integration_works_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuIntegrationWorks}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Integration Works&nbsp;
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpensIntegrationWork
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpensIntegrationWork
                                ? "show"
                                : "collapse"
                            }`}
                          >
                            {roledata.integrationlibrary_view && (
                              <li>
                                <Link
                                  to="integrationlibrary"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Integration Library
                                </Link>
                              </li>
                            )}
                            {roledata.integrationtypemasters_view && (
                              <li>
                                <Link
                                  to="integrationtypemasters"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Interation Type Masters
                                </Link>
                              </li>
                            )}
                            {roledata.requestjson_view && (
                              <li>
                                <Link
                                  to="requestjson"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Request JSON
                                </Link>
                              </li>
                            )}
                            {roledata.responsejson_view && (
                              <li>
                                <Link
                                  to="responsejson"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Response JSON
                                </Link>
                              </li>
                            )}
                            {roledata.requeststatus_view && (
                              <li>
                                <Link
                                  to="requeststatus"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Request Status
                                </Link>
                              </li>
                            )}
                            {roledata.authenticationmethod_view && (
                              <li>
                                <Link
                                  to="authenticationmethod"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Authentication Method
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.sales_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-diagram-3"
                            onClick={this.toggleSubMenuThree}
                          >
                            &nbsp;
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              Sales
                            </span>
                            <i
                              style={{ marginTop: "5px", fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpenthree
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>
                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenthree ? "show" : "collapse"
                            }`}
                          >
                            {roledata.book_policy_view && (
                              <li>
                                <Link
                                  to="policiesformpage"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Book Policy
                                </Link>
                              </li>
                            )}
                            {roledata.bulkquote_view && (
                              <li>
                                <Link
                                  to="generatebulkquote"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Generate Bulk Quote (US)
                                </Link>
                              </li>
                            )}
                            {roledata.bulkquote_view && (
                              <li>
                                <Link
                                  to="bulkquote"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Policy
                                </Link>
                              </li>
                            )}

                            {roledata.premium_register_view && (
                              <li>
                                <Link
                                  to="premiumregisterentry"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-person"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Premium Register Entry
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count15}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.posp_e_view && (
                              <li>
                                <Link to="posp" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  POSP
                                </Link>
                              </li>
                            )}

                            {roledata.create_posp_view && (
                              <li>
                                <Link to="cposp" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-1-square-fill"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Create POSP
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count0}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.posp_additional_details_view && (
                              <li>
                                <Link to="dposp" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-2-square-fill"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    POSP&nbsp;Additional&nbsp;Details
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count1}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.verify_posp_marksheet_view && (
                              <li>
                                <Link
                                  to="markup"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-3-square-fill"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Upload POSP Marksheet
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count3}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.operation_table_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-house-gear"
                            onClick={this.toggleSubMenuFour}
                          >
                            &nbsp;
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              Operations
                            </span>
                            <i
                              style={{ marginTop: "5px", fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpenfour
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>
                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenfour ? "show" : "collapse"
                            }`}
                          >
                            {roledata.premium_register_verification_view && (
                              <li>
                                <Link
                                  to="premiumregisterverification"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-person"></span>
                                  </div>

                                  <div
                                    style={{
                                      whiteSpace: "nowrap",

                                      overflow: "hidden",

                                      textOverflow: "ellipsis",

                                      maxWidth: "120px", // Adjust this based on available space
                                    }}
                                  >
                                    Premium Register Verification
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count13}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.premium_register_approval_view && (
                              <li>
                                <Link
                                  to="premiumregisterapproval"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-person"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Premium Register Approval
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count14}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.verify_posp_with_irda_view && (
                              <li>
                                <Link
                                  to="ipospv"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-up-square"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Verify POSP With IRDA
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.posp_details_verfication_view && (
                              <li>
                                <Link
                                  to="iposdp"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-up-square"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    POSP Details Verfication
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count2}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.posp_marksheet_approval_view && (
                              <li>
                                <Link to="markv" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-up-square"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    POSP Marksheet Approval
                                  </div>

                                  <div
                                    style={{
                                      position: "relative",

                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="bi bi-bell"
                                      style={{
                                        fontSize: "14px",

                                        color: "black", // Adjust color as needed
                                      }}
                                    ></i>

                                    <div className="absolute-badge">
                                      {this.state.count4}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.un_characterised_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-box-seam"
                            onClick={this.toggleSubMenuFive}
                          >
                            &nbsp;
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              Uncategorized
                            </span>
                            <i
                              style={{ marginTop: "5px", fontSize: "15px" }}
                              className={`bi ${
                                isSubMenuOpenfive
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>
                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenfive ? "show" : "collapse"
                            }`}
                          >
                            {roledata.posp_id_approval_view && (
                              <li>
                                <Link
                                  to="pospcr"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-4-square-fill"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    POSP ID Approval
                                  </div>
                                </Link>
                              </li>
                            )}
                            {roledata.users_view && (
                              <li>
                                <Link to="users" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="bi bi-person"></span>
                                  </div>
                                  Users
                                </Link>
                              </li>
                            )}

                            {roledata.api_page_view && (
                              <li>
                                <Link
                                  to="/apipage"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-app-indicator"></span>
                                  </div>

                                  <span>API Page</span>
                                </Link>
                              </li>
                            )}

                            {roledata.templates_view && (
                              <li>
                                <Link
                                  to="templates"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-journal-text"></span>
                                  </div>
                                  Templates
                                </Link>
                              </li>
                            )}

                            {roledata.sourced_policies_view && (
                              <li>
                                <Link
                                  to="sourcedpolicies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-file-earmark-text-fill"></span>
                                  </div>

                                  <span className="menu_text">
                                    Sourced Policies
                                  </span>
                                </Link>
                              </li>
                            )}

                            {roledata.draft_policies_view && (
                              <li>
                                <Link
                                  to="draftpolicies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-file-earmark-fill"></span>
                                  </div>

                                  <span className="menu_text">
                                    Draft Policies
                                  </span>
                                </Link>
                              </li>
                            )}

                            {roledata.customers_view && (
                              <li>
                                <Link
                                  to="customers"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Customers
                                </Link>
                              </li>
                            )}
                            {roledata.insurance_types_view && (
                              <li>
                                <Link
                                  to="insurancetypes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-receipt-cutoff"></span>
                                  </div>

                                  <span className="menu_text">
                                    Insurance types
                                  </span>
                                </Link>
                              </li>
                            )}

                            {roledata.settings_view && (
                              <li>
                                <Link
                                  to="settings"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-gear"></span>
                                  </div>

                                  <span className="menu_text">Settings</span>
                                </Link>
                              </li>
                            )}

                            {roledata.zones_view && (
                              <li>
                                <Link to="zones" className="nav-link collapsed">
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-gear"></span>
                                  </div>

                                  <span className="menu_text">Zones</span>
                                </Link>
                              </li>
                            )}

                            {roledata.zipcodes_view && (
                              <li>
                                <Link
                                  to="zipcodes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-geo-fill"></span>
                                  </div>

                                  <span className="menu_text">Zipcodes</span>
                                </Link>
                              </li>
                            )}

                            {roledata.plan_types_view && (
                              <li>
                                <Link
                                  to="plantypes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-geo-fill"></span>
                                  </div>
                                  <span className="menu_text">Plan Types</span>
                                </Link>
                              </li>
                            )}

                            {roledata.family_definitions_view && (
                              <li>
                                <Link
                                  to="familydefinitions"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-geo-fill"></span>
                                  </div>

                                  <span className="menu_text">
                                    Family definitions
                                  </span>
                                </Link>
                              </li>
                            )}

                            {roledata.age_bands_view && (
                              <li>
                                <Link
                                  to="agebands"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-geo-fill"></span>
                                  </div>

                                  <span className="menu_text">Age Bands</span>
                                </Link>
                              </li>
                            )}

                            {roledata.gender_view && (
                              <li>
                                <Link
                                  to="gender"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Gender
                                </Link>
                              </li>
                            )}

                            {roledata.insurance_categories_view && (
                              <li>
                                <Link
                                  to="insurancecategories"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Insurance Categories
                                </Link>
                              </li>
                            )}

                            {roledata.relationships_view && (
                              <li>
                                <Link
                                  to="relationships"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Relationships
                                </Link>
                              </li>
                            )}

                            {roledata.employeetype_view && (
                              <li>
                                <Link
                                  to="employeetype"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Employeetype
                                </Link>
                              </li>
                            )}

                            {roledata.leavetypes_view && (
                              <li>
                                <Link
                                  to="leavetypes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Leavetypes
                                </Link>
                              </li>
                            )}

                            {roledata.holidayslist_view && (
                              <li>
                                <Link
                                  to="holidayslist"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Holidayslist
                                </Link>
                              </li>
                            )}

                            {roledata.irda_insurance_categories_view && (
                              <li>
                                <Link
                                  to="irdainsurancecategories"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    IRDA Insurance Categories
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.role_items_view && (
                              <li>
                                <Link
                                  to="roleitems"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Role Items
                                </Link>
                              </li>
                            )}
                            {roledata.workdesk_view && (
                              <li>
                                <Link
                                  to="workdesk"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Workdesk&nbsp;
                                  <div style={iconStyle}>
                                    {this.state.count12} &nbsp;
                                    {this.state.count11}
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.lifeinsurancecompanies_view && (
                              <li>
                                <Link
                                  to="lifeinsurancecompanies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Life-insurance companies
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.nonlifeinsurancecompanies_view && (
                              <li>
                                <Link
                                  to="nonlifeinsurancecompanies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Non-Life insurance companies
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.liferidersinsurancecompanies_view && (
                              <li>
                                <Link
                                  to="liferidersinsurancecompanies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>

                                  <div className="ellipsis-text">
                                    Life-riders Insurance companies
                                  </div>
                                </Link>
                              </li>
                            )}

                            {roledata.irdainsurancetypesnonlife_view && (
                              <li>
                                <Link
                                  to="irdainsurancetypesnonlife"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Irdainsurancetypesnonlife
                                </Link>
                              </li>
                            )}

                            {roledata.irdainsurancetypeliferiders_view && (
                              <li>
                                <Link
                                  to="irdainsurancetypeliferiders"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Irdainsurancetypeliferiders
                                </Link>
                              </li>
                            )}

                            {roledata.irdainsurancetypeslife_view && (
                              <li>
                                <Link
                                  to="irdainsurancetypeslife"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Irdainsurancetypeslife
                                </Link>
                              </li>
                            )}

                            {roledata.plantypelinkedunlinked_view && (
                              <li>
                                <Link
                                  to="plantypelinkedunlinked"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Plantypelinkedunlinked
                                </Link>
                              </li>
                            )}

                            {roledata.commissionmasternonlife_view && (
                              <li>
                                <Link
                                  to="commissionmasternonlife"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Commissionmasternonlife
                                </Link>
                              </li>
                            )}

                            {roledata.bookedpoliciesnonlife_view && (
                              <li>
                                <Link
                                  to="bookedpoliciesnonlife"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bookedpoliciesnonlife
                                </Link>
                              </li>
                            )}

                            {roledata.chitokensessiontoken_view && (
                              <li>
                                <Link
                                  to="chitokensessiontoken"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  CHI Token Session Token
                                </Link>
                              </li>
                            )}

                            {roledata.chihealthplansintegrated_view && (
                              <li>
                                <Link
                                  to="chihealthplansintegrated"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  CHI Health Plans Integrated
                                </Link>
                              </li>
                            )}

                            {roledata.chitokensessiontokentwo_view && (
                              <li>
                                <Link
                                  to="chitokensessiontokentwo"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  CHI Token Session Token two
                                </Link>
                              </li>
                            )}

                            {roledata.caresupremeaddons_view && (
                              <li>
                                <Link
                                  to="caresupremeaddons"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health AddOns
                                </Link>
                              </li>
                            )}

                            {roledata.covertype_view && (
                              <li>
                                <Link
                                  to="covertype"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Cover Type
                                </Link>
                              </li>
                            )}

                            {roledata.caresupremesuminsuredcodes_view && (
                              <li>
                                <Link
                                  to="caresupremesuminsuredcodes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Care Supreme SumInsured Codes
                                </Link>
                              </li>
                            )}

                            {roledata.caresupremerelationcodes_view && (
                              <li>
                                <Link
                                  to="caresupremerelationcodes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Relation Codes
                                </Link>
                              </li>
                            )}

                            {roledata.caresuprememedicalqns_view && (
                              <li>
                                <Link
                                  to="caresuprememedicalqns"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Care Supreme Medical Questions
                                </Link>
                              </li>
                            )}

                            {roledata.healthcodemasterone_view && (
                              <li>
                                <Link
                                  to="healthcodemasterone"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Code Master One
                                </Link>
                              </li>
                            )}

                            {roledata.healthproductsfeatures_view && (
                              <li>
                                <Link
                                  to="healthproductsfeatures"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Products Features
                                </Link>
                              </li>
                            )}

                            {roledata.healthpincodesmasters_view && (
                              <li>
                                <Link
                                  to="healthpincodesmasters"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health pincodes masters
                                </Link>
                              </li>
                            )}

                            {roledata.healthaddonexclusive_view && (
                              <li>
                                <Link
                                  to="healthaddonexclusive"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health addon exclusive
                                </Link>
                              </li>
                            )}

                            {roledata.healthageaddons_view && (
                              <li>
                                <Link
                                  to="healthageaddons"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health age addons
                                </Link>
                              </li>
                            )}

                            {roledata.healthproducts_view && (
                              <li>
                                <Link
                                  to="healthproducts"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health products
                                </Link>
                              </li>
                            )}

                            {roledata.healthpins_view && (
                              <li>
                                <Link
                                  to="healthpins"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health pins
                                </Link>
                              </li>
                            )}

                            {roledata.healthagebands_view && (
                              <li>
                                <Link
                                  to="healthagebands"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health age bands
                                </Link>
                              </li>
                            )}

                            {roledata.healthfamilydef_view && (
                              <li>
                                <Link
                                  to="healthfamilydef"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health family def
                                </Link>
                              </li>
                            )}

                            {roledata.healthsicodes_view && (
                              <li>
                                <Link
                                  to="healthsicodes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health si codes
                                </Link>
                              </li>
                            )}

                            {roledata.healthpinaddons_view && (
                              <li>
                                <Link
                                  to="healthpinaddons"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health pin addons
                                </Link>
                              </li>
                            )}

                            {roledata.healthoccupations_view && (
                              <li>
                                <Link
                                  to="healthoccupations"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Occupation
                                </Link>
                              </li>
                            )}

                            {roledata.healthcovertypes_view && (
                              <li>
                                <Link
                                  to="healthcovertypes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health cover types
                                </Link>
                              </li>
                            )}

                            {roledata.healthplantype_view && (
                              <li>
                                <Link
                                  to="healthplantype"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health plan type
                                </Link>
                              </li>
                            )}

                            {roledata.healthmaritalstatus_view && (
                              <li>
                                <Link
                                  to="healthmaritalstatus"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health marital status
                                </Link>
                              </li>
                            )}

                            {roledata.healthnationality_view && (
                              <li>
                                <Link
                                  to="healthnationality"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health nationality
                                </Link>
                              </li>
                            )}

                            {roledata.healthnomineerelations_view && (
                              <li>
                                <Link
                                  to="healthnomineerelations"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health nominee relations
                                </Link>
                              </li>
                            )}

                            {roledata.healthbusinesstype_view && (
                              <li>
                                <Link
                                  to="healthbusinesstype"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health businesstype
                                </Link>
                              </li>
                            )}

                            {roledata.healthclienttypes_view && (
                              <li>
                                <Link
                                  to="healthclienttypes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health client types
                                </Link>
                              </li>
                            )}
                            {roledata.healthexternalsystem_view && (
                              <li>
                                <Link
                                  to="healthexternalsystem"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health external system
                                </Link>
                              </li>
                            )}

                            {roledata.healthrelationcodes_view && (
                              <li>
                                <Link
                                  to="Healthrelationcodes"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Relation Codes
                                </Link>
                              </li>
                            )}

                            {roledata.healthsiaddons_view && (
                              <li>
                                <Link
                                  to="healthsiaddons"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health si addons
                                </Link>
                              </li>
                            )}

                            {roledata.irdaproductname_view && (
                              <li>
                                <Link
                                  to="irdaproductname"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IRDA Product Name
                                </Link>
                              </li>
                            )}

                            {roledata.healthreliancepins_view && (
                              <li>
                                <Link
                                  to="healthreliancepins"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Health Reliance Pins
                                </Link>
                              </li>
                            )}

                            {roledata.godigithealthpinmaster_view && (
                              <li>
                                <Link
                                  to="godigithealthpinmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Godigit Health Pin Master
                                </Link>
                              </li>
                            )}

                            {roledata.premiumapprovalentry_view && (
                              <li>
                                <Link
                                  to="premiumapprovalentry"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Premium Approval Entry
                                </Link>
                              </li>
                            )}

                            {roledata.icicihealthpincodes_view && (
                              <li>
                                <Link
                                  to="icicihealthpincodes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  ICICI Health Pin Codes
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.charts_library_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuEight}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Charts&nbsp;
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpeneight
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpeneight ? "show" : "collapse"
                            }`}
                          >
                            {roledata.widgetslibrary_view && (
                              <li>
                                <Link
                                  to="widgetslibrary"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Widgets Library
                                </Link>
                              </li>
                            )}

                            {roledata.widgetsrightstable_view && (
                              <li>
                                <Link
                                  to="widgetsrightstable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Widgets Rights Table
                                </Link>
                              </li>
                            )}

                            {roledata.book_policy_view && (
                              <li>
                                <Link
                                  to="widgetdef"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Widget Form
                                </Link>
                              </li>
                            )}

                            {roledata.widgetdashboard_view && (
                              <li>
                                <Link
                                  to="widgetdashboard"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Dashboard
                                </Link>
                              </li>
                            )}

                            {roledata.widgetdefinition_view && (
                              <li>
                                <Link
                                  to="widgetdefinition"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Widget Definition
                                </Link>
                              </li>
                            )}

                            {roledata.drilldown_view && (
                              <li>
                                <Link
                                  to="drilldown"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  widget Drilldown
                                </Link>
                              </li>
                            )}

                            {roledata.userwidgetactivitylog_view && (
                              <li>
                                <Link
                                  to="userwidgetactivitylog"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  User Widget activity log
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.abha_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded 
                            bi bi-pc-display-horizontal"
                            onClick={this.toggleHealthMenu}
                            style={{}}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "14px", paddingLeft: "5px" }}
                            >
                              Health
                            </span>
                            <i
                              className={`bi ${
                                isSubMenuOpenHealth
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpenHealth ? "show" : "collapse"
                            }`}
                          >
                            {roledata.companies_view && (
                              <li>
                                <Link
                                  to="companies"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="Icon_size bi bi-file-earmark-spreadsheet"></span>
                                  </div>

                                  <span className="menu_text">Companies</span>
                                </Link>
                              </li>
                            )}
                            {roledata.company_view && (
                              <li>
                                <Link
                                  to="company"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Company
                                </Link>
                              </li>
                            )}
                            {roledata.stagingmemberstable_view && (
                              <li>
                                <Link
                                  to="stagingmemberstable"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Bulk Employees Upload
                                </Link>
                              </li>
                            )}
                            {roledata.healthmemberdata_view && (
                              <li>
                                <Link
                                  to="healthmemberdata"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Health Member Data
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.healthmemberdata_view && (
                              <li>
                                <Link
                                  to="healthmemberexport"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Health Member Export
                                </Link>
                              </li>
                            )}
                            {roledata.employeestatusmaster_view && (
                              <li>
                                <Link
                                  to="employeestatusmaster"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Employeestatus Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.companyhasemployees_view && (
                              <li>
                                <Link
                                  to="companyhasemployees"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Company Has Employees
                                </Link>
                              </li>
                            )}
                            {roledata.employeefamilymanagement_view && (
                              <li>
                                <Link
                                  to="employeefamilymanagement"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Employee Family Management
                                </Link>
                              </li>
                            )}
                            {roledata.industrytypemaster_view && (
                              <li>
                                <Link
                                  to="industrytypemaster"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-box-arrow-in-right"></span>
                                  </div>
                                  Industry Type Master
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.rules_dropdown_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded 
                            bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuSix}
                            style={{}}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "14px", paddingLeft: "5px" }}
                            >
                              Rules
                            </span>
                            <i
                              className={`bi ${
                                isSubMenuOpensix
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpensix ? "show" : "collapse"
                            }`}
                          >
                            {roledata.rule_page_view && (
                              <li>
                                <Link
                                  to="/rulespage"
                                  className="nav-link collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-receipt-cutoff"></span>
                                  </div>
                                  Rules Page
                                </Link>
                              </li>
                            )}
                            {roledata.rulegroups_view && (
                              <li>
                                <Link
                                  to="rulegroups"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Groups
                                </Link>
                              </li>
                            )}
                            {roledata.rulesdef_view && (
                              <li>
                                <Link
                                  to="rulesdef"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rules Def
                                </Link>
                              </li>
                            )}
                            {roledata.actiontypes_view && (
                              <li>
                                <Link
                                  to="actiontypes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Action Types
                                </Link>
                              </li>
                            )}
                            {roledata.ruleactions_view && (
                              <li>
                                <Link
                                  to="ruleactions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Action
                                </Link>
                              </li>
                            )}
                            {roledata.ruleflows_view && (
                              <li>
                                <Link
                                  to="ruleflows"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Flows
                                </Link>
                              </li>
                            )}
                            {roledata.ruleflowsteps_view && (
                              <li>
                                <Link
                                  to="ruleflowsteps"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Flow Steps
                                </Link>
                              </li>
                            )}
                            {roledata.apiendpoint_view && (
                              <li>
                                <Link
                                  to="apiendpoint"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Api End Point
                                </Link>
                              </li>
                            )}
                            {roledata.emailtemplates_view && (
                              <li>
                                <Link
                                  to="emailtemplates"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Email Templates
                                </Link>
                              </li>
                            )}
                            {roledata.smstemplates_view && (
                              <li>
                                <Link
                                  to="smstemplates"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Sms Templates
                                </Link>
                              </li>
                            )}
                            {roledata.ruleexecutionhistory_view && (
                              <li>
                                <Link
                                  to="ruleexecutionhistory"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Execution History
                                </Link>
                              </li>
                            )}
                            {roledata.actionexecutionhistory_view && (
                              <li>
                                <Link
                                  to="actionexecutionhistory"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Action Execution History
                                </Link>
                              </li>
                            )}
                            {roledata.ruleconditions_view && (
                              <li>
                                <Link
                                  to="ruleconditions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Conditions
                                </Link>
                              </li>
                            )}
                            {roledata.ruletesttable_view && (
                              <li>
                                <Link
                                  to="ruletesttable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Test Table
                                </Link>
                              </li>
                            )}
                            {roledata.table_rule_triggers_view && (
                              <li>
                                <Link
                                  to="table_rule_triggers"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Table Rule Triggers
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.rule_execution_queue_view && (
                              <li>
                                <Link
                                  to="rule_execution_queue"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Execution Queue
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.table_metadata_view && (
                              <li>
                                <Link
                                  to="table_metadata"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Table Metadata
                                </Link>
                              </li>
                            )}
                            {roledata.rule_execution_performance_view && (
                              <li>
                                <Link
                                  to="rule_execution_performance"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Execution Performance
                                </Link>
                              </li>
                            )}
                            {roledata.hook_execution_log_view && (
                              <li>
                                <Link
                                  to="hook_execution_log"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Hook Execution Log
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.rule_trigger_config_view && (
                              <li>
                                <Link
                                  to="rule_trigger_config"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Trigger Config
                                </Link>
                              </li>
                            )}
                            {roledata.parameter_mapping_templates_view && (
                              <li>
                                <Link
                                  to="parameter_mapping_templates"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Parameter Mapping Templates
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.rule_execution_alerts_view && (
                              <li>
                                <Link
                                  to="rule_execution_alerts"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rule Execution Alerts
                                </Link>
                              </li>
                            )}{" "}
                          </ul>
                        </li>
                      )}
                      {roledata.chatbot_view && (
                        <li className="nav-item active ">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.toggleSubMenuNine}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Chatbot
                            </span>

                            <i
                              className={`bi ${
                                isSubMenuOpennine
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSubMenuOpennine ? "show" : "collapse"
                            }`}
                          >
                            {roledata.chatbotconversations_view && (
                              <li>
                                <Link
                                  to="chatbotconversations"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chat Bot Conversations
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotconfig_view && (
                              <li>
                                <Link
                                  to="chatbotconfig"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbotconfig
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotmessages_view && (
                              <li>
                                <Link
                                  to="chatbotmessages"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Messages
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotactiontypemaster_view && (
                              <li>
                                <Link
                                  to="chatbotactiontypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Action Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotintents_view && (
                              <li>
                                <Link
                                  to="chatbotintents"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Intents
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotuserfeedback_view && (
                              <li>
                                <Link
                                  to="chatbotuserfeedback"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot User Feedback
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotlearningsource_view && (
                              <li>
                                <Link
                                  to="chatbotlearningsource"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Learning Source
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotlearning_view && (
                              <li>
                                <Link
                                  to="chatbotlearning"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Learning
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotuserrights_view && (
                              <li>
                                <Link
                                  to="chatbotuserrights"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot User Rights
                                </Link>
                              </li>
                            )}{" "}
                          </ul>
                        </li>
                      )}
                      {roledata.widgetsviews_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.handlewidgetSidenav}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Widgets & Role Forms
                            </span>

                            <i
                              className={`bi ${
                                isSidenavwidgetOpen
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isSidenavwidgetOpen ? "show" : "collapse"
                            }`}
                          >
                            {roledata.page_layouts_view && (
                              <li>
                                <Link
                                  to="page_layouts"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Page Layouts
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.layout_rows_view && (
                              <li>
                                <Link
                                  to="layout_rows"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Layout Rows
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.layout_cells_view && (
                              <li>
                                <Link
                                  to="layout_cells"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Layout Cells
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.widget_instances_view && (
                              <li>
                                <Link
                                  to="widget_instances"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Instances
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.widget_library_categories_view && (
                              <li>
                                <Link
                                  to="widget_library_categories"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Library Categories
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.table_form_mapping_view && (
                              <li>
                                <Link
                                  to="table_form_mapping"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Table Form Mapping
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.widget_types_view && (
                              <li>
                                <Link
                                  to="widget_types"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Types
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.widget_event_bindings_view && (
                              <li>
                                <Link
                                  to="widget_event_bindings"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Event Bindings{" "}
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.form_field_validations_view && (
                              <li>
                                <Link
                                  to="form_field_validations"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Form Field Validations
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.user_preferences_view && (
                              <li>
                                <Link
                                  to="user_preferences"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  User Preferences
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.user_dashboard_configs_view && (
                              <li>
                                <Link
                                  to="user_dashboard_configs"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  User Dashboard Configs
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.resource_permissions_view && (
                              <li>
                                <Link
                                  to="resource_permissions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Resource Permissions
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.user_feature_flags_view && (
                              <li>
                                <Link
                                  to="user_feature_flags"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  User Feature Flags
                                </Link>
                              </li>
                            )}
                            {roledata.companytypemasternew_view && (
                              <li>
                                <Link
                                  to="companytypemasternew"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Company Typemaster_NEW
                                </Link>
                              </li>
                            )}
                            {roledata.contenttypemasternew_view && (
                              <li>
                                <Link
                                  to="contenttypemasternew"
                                  className="nav-link active collapsed"
                                >
                                  <div className="bnav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Content Typemaster_NEW
                                </Link>
                              </li>
                            )}
                            {roledata.testtablenew_view && (
                              <li>
                                <Link
                                  to="businesstypemasternew"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Testtable_NEW
                                </Link>
                              </li>
                            )}
                            {roledata.widgetinstancesmanager_view && (
                              <li>
                                <Link
                                  to="widgetinstancesmanager"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Instances Manager
                                </Link>
                              </li>
                            )}
                            {roledata.widgeteventcontext_view && (
                              <li>
                                <Link
                                  to="widgeteventcontext"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Event Context
                                </Link>
                              </li>
                            )}
                            {roledata.widgetpagerenderer_view && (
                              <li>
                                <Link
                                  to="widgetpagerenderer"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Page Renderer
                                </Link>
                              </li>
                            )}
                            {roledata.widgetregistry_view && (
                              <li>
                                <Link
                                  to="widgetregistry"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Registry
                                </Link>
                              </li>
                            )}
                            {roledata.widgetrenderer_view && (
                              <li>
                                <Link
                                  to="widgetrenderer"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Renderer
                                </Link>
                              </li>
                            )}
                            {roledata.dynamicformadapter_view && (
                              <li>
                                <Link
                                  to="dynamicformadapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Dynamic Form Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.highchartsadapter_view && (
                              <li>
                                <Link
                                  to="highchartsadapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Highcharts Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.kpicardadapter_view && (
                              <li>
                                <Link
                                  to="kpicardadapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  KPI Card Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.primereacttableadapter_view && (
                              <li>
                                <Link
                                  to="primereacttableadapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Prime ReactT ableAdapter
                                </Link>
                              </li>
                            )}
                            {roledata.reactdatatableadapter_view && (
                              <li>
                                <Link
                                  to="reactdatatableadapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  React DataTable Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.searchfilteradapter_view && (
                              <li>
                                <Link
                                  to="searchfilteradapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Search Filter Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.statichtmladapter_view && (
                              <li>
                                <Link
                                  to="statichtmladapter"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Static Html Adapter
                                </Link>
                              </li>
                            )}
                            {roledata.widgeterrorboundary_view && (
                              <li>
                                <Link
                                  to="widgeterrorboundary"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Error Boundary
                                </Link>
                              </li>
                            )}
                            {roledata.widgetloader_view && (
                              <li>
                                <Link
                                  to="widgetloader"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget Loader
                                </Link>
                              </li>
                            )}
                            {roledata.columnconfigeditor_view && (
                              <li>
                                <Link
                                  to="columnconfigeditor"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Column Config Editor
                                </Link>
                              </li>
                            )}
                            {roledata.dashboardbuilder_view && (
                              <li>
                                <Link
                                  to="dashboardbuilder"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Dashboard Builder
                                </Link>
                              </li>
                            )}
                            {roledata.formconfigeditor_view && (
                              <li>
                                <Link
                                  to="formconfigeditor"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Form Config Editor
                                </Link>
                              </li>
                            )}
                            {roledata.layouteditor_view && (
                              <li>
                                <Link
                                  to="layouteditor"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Layout Editor
                                </Link>
                              </li>
                            )}
                            {roledata.layoutpreview_view && (
                              <li>
                                <Link
                                  to="layoutpreview"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Layout Preview
                                </Link>
                              </li>
                            )}
                            {roledata.widgetinstanceeditor_view && (
                              <li>
                                <Link
                                  to="widgetinstanceeditor"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Widget InstanceEditor
                                </Link>
                              </li>
                            )}
                            {roledata.data_access_rules_view && (
                              <li>
                                <Link
                                  to="data_access_rules"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Data Access Rules
                                </Link>
                              </li>
                            )}
                            {roledata.field_access_rules_view && (
                              <li>
                                <Link
                                  to="field_access_rules"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Field Access Rules
                                </Link>
                              </li>
                            )}
                            {roledata.hierarchy_cache_view && (
                              <li>
                                <Link
                                  to="hierarchy_cache"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Hierarchy Cache
                                </Link>
                              </li>
                            )}
                            {roledata.permissiontypemaster_view && (
                              <li>
                                <Link
                                  to="permissiontypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Permission Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.accessscopetypemaster_view && (
                              <li>
                                <Link
                                  to="accessscopetypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Acess Scope Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.statustypemaster_view && (
                              <li>
                                <Link
                                  to="statustypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Status Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.role_permissions_view && (
                              <li>
                                <Link
                                  to="role_permissions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Role Permissions
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.permission_modules_view && (
                              <li>
                                <Link
                                  to="permission_modules"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Permission Modules
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.user_roles_view && (
                              <li>
                                <Link
                                  to="user_roles"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  User Roles
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.table_permissions_view && (
                              <li>
                                <Link
                                  to="table_permissions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Table Permissions
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.rbac_audit_log_view && (
                              <li>
                                <Link
                                  to="rbac_audit_log"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Rbac Audit Log
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.permission_resources_view && (
                              <li>
                                <Link
                                  to="permission_resources"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Permission Resources
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.usercontexttypemaster_view && (
                              <li>
                                <Link
                                  to="usercontexttypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  User Context Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.accessleveltypemaster_view && (
                              <li>
                                <Link
                                  to="accessleveltypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Access Level Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.user_contexts_view && (
                              <li>
                                <Link
                                  to="user_contexts"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  User Contexts
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.permission_conditions_view && (
                              <li>
                                <Link
                                  to="permission_conditions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Permission Conditions
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.noncategoriesviews_view && (
                        <li className="nav-item active">
                          <div
                            className="nav-link menu-expanded bi bi-pc-display-horizontal"
                            onClick={this.handlenoncategSidenav}
                          >
                            <span
                              className="menu-title"
                              style={{ fontSize: "15px" }}
                            >
                              &nbsp;Non Categories
                            </span>

                            <i
                              className={`bi ${
                                isnocategSidenavOpen
                                  ? "bi-caret-down"
                                  : "bi-caret-right"
                              }`}
                            ></i>

                            <i className="mdi mdi-crosshairs-gps menu-icon"></i>
                          </div>

                          <ul
                            className={`nav flex-column sub-menu ${
                              isnocategSidenavOpen ? "show" : "collapse"
                            }`}
                          >
                            {roledata.apnapolicysubscribe_view && (
                              <li>
                                <Link
                                  to="apnapolicysubscribe"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Apnapolicy Subscribe
                                </Link>
                              </li>
                            )}
                            {roledata.externalencryptions_view && (
                              <li>
                                <Link
                                  to="externalencryptions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  External Encryptions
                                </Link>
                              </li>
                            )}
                            {roledata.officeslist_view && (
                              <li>
                                <Link
                                  to="officeslist"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Offices
                                </Link>
                              </li>
                            )}
                            {/* {roledata.countriesstatescity_view && (
                        <li>
                          <Link
                            to="countriesstatescity"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Countires
                          </Link>
                        </li>
                      )}
                      {roledata.checklistsmaster_view && (
                        <li>
                          <Link
                            to="checklistsmaster"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Checklist Master
                          </Link>
                        </li>
                      )}
                      {roledata.organizations_view && (
                        <li>
                          <Link
                            to="organizations"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Organizations
                          </Link>
                        </li>
                      )}
                      {roledata.policy_view && (
                        <li>
                          <Link
                            to="policy"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Policy
                          </Link>
                        </li>
                      )}
                      {roledata.member_view && (
                        <li>
                          <Link
                            to="member"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Member
                          </Link>
                        </li>
                      )}
                      {roledata.accountdetails_view && (
                        <li>
                          <Link
                            to="accountdetails"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Account Details
                          </Link>
                        </li>
                      )}
                      {roledata.ped_view && (
                        <li>
                          <Link to="ped" className="nav-link active collapsed">
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Ped
                          </Link>
                        </li>
                      )}
                      {roledata.leadopportunity_view && (
                        <li>
                          <Link
                            to="leadopportunity"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Lead oppurtunity
                          </Link>
                        </li>
                      )}
                      {roledata.address_view && (
                        <li>
                          <Link
                            to="address"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Address
                          </Link>
                        </li>
                      )}
                      {roledata.transactionstable_view && (
                        <li>
                          <Link
                            to="transactionstable"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Transactions Table
                          </Link>
                        </li>
                      )}
                      {roledata.events_view && (
                        <li>
                          <Link
                            to="events"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Events
                          </Link>
                        </li>
                      )}
                      {roledata.meetings_view && (
                        <li>
                          <Link
                            to="meetings"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Meetings
                          </Link>
                        </li>
                      )}
                      {roledata.attendees_view && (
                        <li>
                          <Link
                            to="attendees"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Attendees
                          </Link>
                        </li>
                      )}
                      {roledata.claims_view && (
                        <li>
                          <Link
                            to="claims"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Claims
                          </Link>
                        </li>
                      )}
                      {roledata.termsheets_view && (
                        <li>
                          <Link
                            to="termsheets"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Term sheets
                          </Link>
                        </li>
                      )}
                      {roledata.coveragecategory_view && (
                        <li>
                          <Link
                            to="coveragecategory"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Coverage Category
                          </Link>
                        </li>
                      )}
                      {roledata.coverages_view && (
                        <li>
                          <Link
                            to="coverages"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Coverages
                          </Link>
                        </li>
                      )}
                      {roledata.termsheetcoverage_view && (
                        <li>
                          <Link
                            to="termsheetcoverage"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Termsheetcoverage Mapping
                          </Link>
                        </li>
                      )}
                      {roledata.contact_view && (
                        <li>
                          <Link
                            to="contact"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Contact
                          </Link>
                        </li>
                      )}
                      {roledata.hospital_view && (
                        <li>
                          <Link
                            to="hospital"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Hospital
                          </Link>
                        </li>
                      )}
                      {roledata.bill_view && (
                        <li>
                          <Link to="bill" className="nav-link active collapsed">
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Bill
                          </Link>
                        </li>
                      )}
                      {roledata.dummyexample_view && (
                        <li>
                          <Link
                            to="dummyexample"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Dummy Example
                          </Link>
                        </li>
                      )}
                      {roledata.testtable_view && (
                        <li>
                          <Link
                            to="testtable"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Test
                          </Link>
                        </li>
                      )} */}
                            {roledata.abhadetails_view && (
                              <li>
                                <Link
                                  to="abhadetails"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  ABHA Details
                                </Link>
                              </li>
                            )}
                            {roledata.zunopages_view && (
                              <li>
                                <Link
                                  to="zunopolicyformpage"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Zuno policy formpage
                                </Link>
                              </li>
                            )}
                            {/* {roledata.sampletesttable_view && (
                        <li>
                          <Link
                            to="sampletesttable"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Sample Test Table
                          </Link>
                        </li>
                      )}{" "} */}
                            {roledata.testcasetypemaster_view && (
                              <li>
                                <Link
                                  to="testcasetypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Testcase Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.testcaseprioritymaster_view && (
                              <li>
                                <Link
                                  to="testcaseprioritymaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>{" "}
                                  Testcase Priority Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.testcasestatusmaster_view && (
                              <li>
                                <Link
                                  to="testcasestatusmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Testcase Status Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.environmentmaster_view && (
                              <li>
                                <Link
                                  to="environmentmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Environment Master
                                </Link>
                              </li>
                            )}
                            {roledata.ittaskstestcaseshistory_view && (
                              <li>
                                <Link
                                  to="ittaskstestcaseshistory"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Tasks Test Cases History
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.yes_no_view && (
                              <li>
                                <Link
                                  to="yes_no"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Yes No
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.trigger_event_type_master_view && (
                              <li>
                                <Link
                                  to="trigger_event_type_master"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Trigger Event Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.attachmenttypemaster_view && (
                              <li>
                                <Link
                                  to="attachmenttypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Attachment Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.ittaskstestcasesattachments_view && (
                              <li>
                                <Link
                                  to="ittaskstestcasesattachments"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Tasks Test Cases Attachments
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.ittaskstestcases_view && (
                              <li>
                                <Link
                                  to="ittaskstestcases"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  IT Tasks Test Cases
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.chatbotmessagetypemaster_view && (
                              <li>
                                <Link
                                  to="chatbotmessagetypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Chatbot Message Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {/* {roledata.conversations_view && (
                        <li>
                          <Link
                            to="conversations"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Conversations
                          </Link>
                        </li>
                      )}{" "} */}
                            {roledata.deploymentstatus_view && (
                              <li>
                                <Link
                                  to="deploymentstatus"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Deployment Status
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.cross_table_lookup_cache_view && (
                              <li>
                                <Link
                                  to="cross_table_lookup_cache"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Cross Table Lookup Cache
                                </Link>
                              </li>
                            )}
                            {roledata.universalsomporater_view && (
                              <li>
                                <Link
                                  to="universalsomporater"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Universal Sompo Rater
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.universalsompoaddonrater_view && (
                              <li>
                                <Link
                                  to="universalsompoaddonrater"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Universal Sompo Addon Rater
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkimportstatusmaster_view && (
                              <li>
                                <Link
                                  to="bulkimportstatusmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Status Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkimportoperationtypemaster_view && (
                              <li>
                                <Link
                                  to="bulkimportoperationtypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Operation Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkimportoperationstatusmaster_view && (
                              <li>
                                <Link
                                  to="bulkimportoperationstatusmaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Operation Status Master
                                </Link>
                              </li>
                            )}
                            {roledata.bulkimportruletypemaster_view && (
                              <li>
                                <Link
                                  to="bulkimportruletypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Rule Type Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkimportprioritymaster_view && (
                              <li>
                                <Link
                                  to="bulkimportprioritymaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Priority Master
                                </Link>
                              </li>
                            )}
                            {roledata.import_sessions_view && (
                              <li>
                                <Link
                                  to="import_sessions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Sessions
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.import_field_mappings_view && (
                              <li>
                                <Link
                                  to="import_field_mappings"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Field Mappings
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.import_process_logs_view && (
                              <li>
                                <Link
                                  to="import_process_logs"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Process Logs
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.import_validation_rules_view && (
                              <li>
                                <Link
                                  to="import_validation_rules"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Validation Rules
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.import_templates_view && (
                              <li>
                                <Link
                                  to="import_templates"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Templates
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.import_queue_view && (
                              <li>
                                <Link
                                  to="import_queue"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Import Queue
                                </Link>
                              </li>
                            )}
                            {roledata.bulkImport_view && (
                              <li>
                                <Link
                                  to="bulkImport"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import
                                </Link>
                              </li>
                            )}
                            {roledata.bulkimportwizard_view && (
                              <li>
                                <Link
                                  to="bulkimportwizard"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Import Wizard
                                </Link>
                              </li>
                            )}
                            {roledata.fieldmappingstep_view && (
                              <li>
                                <Link
                                  to="fieldmappingstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Field Mapping Step
                                </Link>
                              </li>
                            )}
                            {roledata.fileuploadstep_view && (
                              <li>
                                <Link
                                  to="fileuploadstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  File Upload Step
                                </Link>
                              </li>
                            )}
                            {roledata.processingstep_view && (
                              <li>
                                <Link
                                  to="processingstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Processing Step
                                </Link>
                              </li>
                            )}
                            {roledata.resultsstep_view && (
                              <li>
                                <Link
                                  to="resultsstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Results Step
                                </Link>
                              </li>
                            )}
                            {roledata.tableselectionstep_view && (
                              <li>
                                <Link
                                  to="tableselectionstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Table Selection Step
                                </Link>
                              </li>
                            )}
                            {roledata.validationstep_view && (
                              <li>
                                <Link
                                  to="validationstep"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Validation Step
                                </Link>
                              </li>
                            )}
                            {roledata.tw_uat_master_view && (
                              <li>
                                <Link
                                  to="tw_uat_master"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  TW Vehicle Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.tw_rto_master_view && (
                              <li>
                                <Link
                                  to="tw_rto_master"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  TW RTO Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.pincodemaster_view && (
                              <li>
                                <Link
                                  to="pincodemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Pincode Master
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.tatainsurancemaster_view && (
                              <li>
                                <Link
                                  to="tatainsurancemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  TATA Insurance Master
                                </Link>
                              </li>
                            )}
                            {roledata.tata_mmv_master_view && (
                              <li>
                                <Link
                                  to="tata_mmv_master"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  TATA MMV Master
                                </Link>
                              </li>
                            )}
                            {roledata.tata_finance_master_view && (
                              <li>
                                <Link
                                  to="tata_finance_master"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  TATA Finance Master
                                </Link>
                              </li>
                            )}
                            {roledata.universalsompoproducts_view && (
                              <li>
                                <Link
                                  to="universalsompoproducts"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Universal Sompo Products
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.universalsompoaddons_view && (
                              <li>
                                <Link
                                  to="universalsompoaddons"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Universal Sompo Addons
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquoteaddonrequest_view && (
                              <li>
                                <Link
                                  to="bulkquoteaddonrequest"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulkquote Addon Request
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquotebasepremiumrequest_view && (
                              <li>
                                <Link
                                  to="bulkquotebasepremiumrequest"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulkquote Base premium Request
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.universalpincodes_view && (
                              <li>
                                <Link
                                  to="universalpincodes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Universal Pincodes
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquotesummary_view && (
                              <li>
                                <Link
                                  to="bulkquotesummary"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulkquote Summary
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquoterequest_view && (
                              <li>
                                <Link
                                  to="bulkquoterequest"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Quote Request
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquoteaddonsummary_view && (
                              <li>
                                <Link
                                  to="bulkquoteaddonsummary"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Quote Addon Summary
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.motorproducts_view && (
                              <li>
                                <Link
                                  to="motorproducts"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Motor Products
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.motoraddonstable_view && (
                              <li>
                                <Link
                                  to="motoraddonstable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Motor Addons- Table
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.magmarater_view && (
                              <li>
                                <Link
                                  to="magmarater"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Magma Rater
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.magmapincodes_view && (
                              <li>
                                <Link
                                  to="magmapincodes"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Magma Pincodes
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.altertabletesting_view && (
                              <li>
                                <Link
                                  to="altertabletesting"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Alter Table Testing
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.bulkquoteefd_view && (
                              <li>
                                <Link
                                  to="bulkquoteefd"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Bulk Quote Efd
                                </Link>
                              </li>
                            )}{" "}
                            <li>
                              <Link
                                to="deals"
                                className="nav-link active collapsed"
                              >
                                <div className="nav-link-icon">
                                  <span className="bi bi-speedometer2"></span>
                                </div>
                                Deals
                              </Link>
                            </li>
                            {roledata.dummytable_view && (
                              <li>
                                <Link
                                  to="dummytable"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Dummy Table{" "}
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.testtableoone_view && (
                              <li>
                                <Link
                                  to="testtableoone"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Test Table One
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.testtabletwo_view && (
                              <li>
                                <Link
                                  to="testtabletwo"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-speedometer2"></span>
                                  </div>
                                  Test Table Two
                                </Link>
                              </li>
                            )}
                            {roledata.audit_log_config_view && (
                              <li>
                                <Link
                                  to="audit_log_config"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Audit Log Config
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.audit_logs_view && (
                              <li>
                                <Link
                                  to="audit_logs"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Audit Logs
                                </Link>
                              </li>
                            )}{" "}
                            {roledata.employeestatusmasternew_view && (
                              <li>
                                <Link
                                  to="employeestatusmasternew"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Employee Statusmaster_NEW
                                </Link>
                              </li>
                            )}
                            {roledata.events_view && (
                              <li>
                                <Link
                                  to="events"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Events
                                </Link>
                              </li>
                            )}
                            {roledata.eventactions_view && (
                              <li>
                                <Link
                                  to="eventactions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Event Actions
                                </Link>
                              </li>
                            )}
                            {roledata.event_conditions_view && (
                              <li>
                                <Link
                                  to="event_conditions"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Event Conditions
                                </Link>
                              </li>
                            )}
                            {roledata.event_queue_view && (
                              <li>
                                <Link
                                  to="event_queue"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Event Queue
                                </Link>
                              </li>
                            )}
                            {roledata.eventtypemaster_view && (
                              <li>
                                <Link
                                  to="eventtypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Event Type Master
                                </Link>
                              </li>
                            )}
                            {roledata.eventactiontypemaster_view && (
                              <li>
                                <Link
                                  to="eventactiontypemaster"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Event Action Type Master
                                </Link>
                              </li>
                            )}
                            {roledata.testevents_view && (
                              <li>
                                <Link
                                  to="testevents"
                                  className="nav-link active collapsed"
                                >
                                  <div className="nav-link-icon">
                                    <span className="bi bi-arrow-return-right"></span>
                                  </div>
                                  Test Etudents{" "}
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {roledata.itdashboard_view && (
                        <li>
                          <Link
                            to="itdashboard"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            IT Dashboard
                          </Link>
                        </li>
                      )}
                      {roledata.ithomedashboard_view && (
                        <li>
                          <Link
                            to="ithomedashboard"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            IT Home Dashboard
                          </Link>
                        </li>
                      )}
                      {roledata.employeetasksummary_view && (
                        <li>
                          <Link
                            to="employeetasksummary"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Employee Task Summary{" "}
                          </Link>
                        </li>
                      )}
                      {roledata.emailstatusmaster_view && (
                        <li>
                          <Link
                            to="emailstatusmaster"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Email Status Master
                          </Link>
                        </li>
                      )}
                      {roledata.triggermaster_view && (
                        <li>
                          <Link
                            to="triggermaster"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Trigger Master
                          </Link>
                        </li>
                      )}
                      {roledata.tv_tokens_view && (
                        <li>
                          <Link
                            to="tv_tokens"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-arrow-right-short"></span>
                            </div>
                            Tv Tokens
                          </Link>
                        </li>
                      )}
                      {roledata.headersmaster_view && (
                        <li>
                          <Link
                            to="headersmaster"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Headers Master
                          </Link>
                        </li>
                      )}{" "}
                      {roledata.taskpenalitypoints_view && (
                        <li>
                          <Link
                            to="taskpenalitypoints"
                            className="nav-link active collapsed"
                          >
                            <div className="nav-link-icon">
                              <span className="bi bi-speedometer2"></span>
                            </div>
                            Task Penality Points
                          </Link>
                        </li>
                      )}{" "}
                      {/* <-- replace --> } */}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>

            <div id="layoutSidenav_content">
              <main>
                <header className="py-10 mb-4 bg-gradient-primary-to-secondary">
                  <div className="container-fluid-xl px-4">
                    <Routes>
                      <Route path="apipage" element={<APIPage />}></Route>

                      <Route
                        path="mastertable"
                        element={<MasterTable />}
                      ></Route>

                      <Route path="/rulespage" element={<RulePage />}></Route>

                      <Route path="/dashboard" element={<DashBoard />}>
                        <Route
                          path="dashboardcharts"
                          element={<DashboardCharts />}
                        ></Route>
                      </Route>

                      <Route path="agebands" element={<Agebands />} />

                      <Route path="users" element={<Users />}></Route>

                      <Route path="templates" element={<Templates />}></Route>

                      <Route path="customers" element={<Customers />}></Route>

                      <Route path="companies" element={<Companies />} />

                      <Route
                        path="insurancetypes"
                        element={<InsuranceTypes />}
                      />

                      <Route path="settings" element={<Settings />} />

                      <Route path="zones" element={<Zones />} />

                      <Route
                        path="familydefinitions"
                        element={<Familydefinitions />}
                      />

                      <Route path="profile" element={<Profile />} />

                      <Route path="plantypes" element={<Plantypes />} />

                      <Route path="zipcodes" element={<Zipcodes />} />

                      <Route path="draftpolicies" element={<Draftpolicies />} />

                      <Route path="roles" element={<Roles />} />

                      <Route
                        path="sourcedpolicies"
                        element={<Sourcepolicies />}
                      />

                      <Route path="gender" element={<Gender />}></Route>

                      <Route
                        path="insurancecategories"
                        element={<InsuranceCategories />}
                      ></Route>

                      <Route
                        path="relationships"
                        element={<Relationships />}
                      ></Route>

                      <Route
                        path="employeetype"
                        element={<Employeetype />}
                      ></Route>

                      <Route
                        path="departments"
                        element={<Departments />}
                      ></Route>

                      <Route
                        path="designations"
                        element={<Designations />}
                      ></Route>

                      <Route path="leavetypes" element={<Leavetypes />}></Route>

                      <Route
                        path="holidayslist"
                        element={<Holidayslist />}
                      ></Route>

                      <Route path="offices" element={<Offices />}></Route>

                      <Route
                        path="irdainsurancecategories"
                        element={<Irdainsurancecategories />}
                      ></Route>

                      <Route path="roleitems" element={<Roleitems />}></Route>

                      <Route path="employees" element={<Employees />}></Route>

                      <Route path="posp" element={<Posp />}></Route>

                      <Route
                        path="pospprofile"
                        element={<Pospprofile />}
                      ></Route>

                      <Route path="workdesk" element={<Workdesk />}></Route>

                      <Route
                        path="leaverequestapprovals"
                        element={<Leaverequestapprovals />}
                      ></Route>

                      <Route
                        path="lifeinsurancecompanies"
                        element={<Lifeinsurancecompanies />}
                      ></Route>

                      <Route
                        path="nonlifeinsurancecompanies"
                        element={<Nonlifeinsurancecompanies />}
                      ></Route>

                      <Route
                        path="liferidersinsurancecompanies"
                        element={<Liferidersinsurancecompanies />}
                      ></Route>

                      <Route
                        path="irdainsurancetypesnonlife"
                        element={<Irdainsurancetypesnonlife />}
                      ></Route>

                      <Route
                        path="irdainsurancetypeliferiders"
                        element={<Irdainsurancetypeliferiders />}
                      ></Route>

                      <Route
                        path="irdainsurancetypeslife"
                        element={<Irdainsurancetypeslife />}
                      ></Route>

                      <Route
                        path="plantypelinkedunlinked"
                        element={<Plantypelinkedunlinked />}
                      ></Route>

                      <Route
                        path="commissionmasternonlife"
                        element={<Commissionmasternonlife />}
                      ></Route>

                      <Route
                        path="bookedpoliciesnonlife"
                        element={<Bookedpoliciesnonlife />}
                      ></Route>

                      <Route
                        path="attendancepage"
                        element={<AttendancePage />}
                      ></Route>

                      <Route
                        path="chihealthplansintegrated"
                        element={<Chihealthplansintegrated />}
                      ></Route>

                      <Route
                        path="policiesformpage"
                        element={<PoliciesFormPage />}
                      ></Route>

                      <Route
                        path="policiesformfillingpage"
                        element={<PoliciesFormFillingPage />}
                      ></Route>

                      <Route
                        path="/policiespage"
                        element={<PoliciesPage />}
                      ></Route>

                      <Route
                        path="policiescomparepage"
                        element={<PoliciesComparePage />}
                      ></Route>

                      <Route
                        path="policieskycform"
                        element={<PoliciesKYCForm />}
                      ></Route>

                      <Route
                        path="policiespagepdf"
                        element={<PoliciesPagepdf />}
                      ></Route>

                      <Route
                        path="caresupremeaddons"
                        element={<Caresupremeaddons />}
                      ></Route>

                      <Route path="covertype" element={<Covertype />}></Route>

                      <Route
                        path="caresupremesuminsuredcodes"
                        element={<Caresupremesuminsuredcodes />}
                      ></Route>

                      <Route
                        path="caresupremerelationcodes"
                        element={<Caresupremerelationcodes />}
                      ></Route>

                      <Route
                        path="caresuprememedicalqns"
                        element={<Caresuprememedicalqns />}
                      ></Route>

                      <Route
                        path="proposalsummary"
                        element={<Proposalsummary />}
                      ></Route>

                      <Route path="/addons" element={<AddOns />}></Route>

                      <Route
                        path="nomineedetails"
                        element={<NomineeDetails />}
                      ></Route>

                      <Route path="medicals" element={<Medicals />}></Route>

                      <Route path="memberinfo" element={<Memberinfo />}></Route>

                      <Route
                        path="proposerinfo"
                        element={<Proposerinfo />}
                      ></Route>

                      {/* Godigit Routing */}

                      <Route path="goaddons" element={<GoAddOns />}></Route>

                      <Route
                        path="gonomineedetails"
                        element={<GoNomineeDetails />}
                      ></Route>

                      <Route path="gomedicals" element={<GoMedicals />}></Route>

                      <Route
                        path="gomemberinfo"
                        element={<GoMemberinfo />}
                      ></Route>

                      <Route
                        path="goproposerinfo"
                        element={<GoProposerinfo />}
                      ></Route>

                      <Route
                        path="gopolicysummarypage"
                        element={<GoPolicySummaryPage />}
                      ></Route>

                      {/* <Route path="gopolicieskycform" element={<GoPoliciesKYCForm />}></Route> */}

                      <Route
                        path="gopaymentstatus"
                        element={<GoPolicyKycPage />}
                      ></Route>

                      <Route
                        path="gopolicythankspage"
                        element={<GoPolicyThanksPage />}
                      ></Route>

                      {/*end Godigit Routing */}

                      {/* Reliance Routing */}

                      <Route path="rgiaddOns" element={<RGIAddOns />}></Route>

                      <Route path="rgibuy" element={<RGIBuy />}></Route>

                      <Route
                        path="rgimedicals"
                        element={<RGIMedicals />}
                      ></Route>

                      <Route
                        path="rgimemberinfo"
                        element={<RGIMemberinfo />}
                      ></Route>

                      <Route
                        path="rginomineedetails"
                        element={<RGINomineeDetails />}
                      ></Route>

                      <Route
                        path="rgipolicieskyc"
                        element={<RGIPoliciesKYC />}
                      ></Route>

                      <Route
                        path="rgpaymentstatus"
                        element={<RGIPoliciesThankspage />}
                      ></Route>

                      <Route
                        path="rgiproposalsummary"
                        element={<RGIProposalsummary />}
                      ></Route>

                      <Route
                        path="rgiproposerinfo"
                        element={<RGIProposerinfo />}
                      ></Route>

                      <Route
                        path="healthcodemasterone"
                        element={<Healthcodemasterone />}
                      ></Route>

                      <Route
                        path="employeesprofile"
                        element={<EmployeesProfile />}
                      ></Route>

                      <Route
                        path="employeesprofiles"
                        element={<EmployeesProfiles />}
                      ></Route>

                      <Route
                        path="healthcodemasterone"
                        element={<Healthcodemasterone />}
                      ></Route>

                      <Route
                        path="healthcodemasterone"
                        element={<Healthcodemasterone />}
                      ></Route>

                      <Route
                        path="healthproductsfeatures"
                        element={<Healthproductsfeatures />}
                      ></Route>

                      <Route
                        path="policiesstatus"
                        element={<PoliciesStatus />}
                      ></Route>

                      <Route path="payments" element={<Payments />}></Route>

                      <Route
                        path="healthpincodesmasters"
                        element={<Healthpincodesmasters />}
                      ></Route>

                      <Route
                        path="healthaddonexclusive"
                        element={<Healthaddonexclusive />}
                      ></Route>

                      <Route
                        path="healthageaddons"
                        element={<Healthageaddons />}
                      ></Route>

                      <Route
                        path="healthproducts"
                        element={<Healthproducts />}
                      ></Route>

                      <Route path="healthpins" element={<Healthpins />}></Route>

                      <Route
                        path="healthagebands"
                        element={<Healthagebands />}
                      ></Route>

                      <Route
                        path="healthfamilydef"
                        element={<Healthfamilydef />}
                      ></Route>

                      <Route
                        path="healthsicodes"
                        element={<Healthsicodes />}
                      ></Route>

                      <Route
                        path="healthpinaddons"
                        element={<Healthpinaddons />}
                      ></Route>
                      <Route
                        path="healthoccupations"
                        element={<Healthoccupations />}
                      ></Route>

                      <Route
                        path="healthcovertypes"
                        element={<Healthcovertypes />}
                      ></Route>

                      <Route
                        path="healthplantype"
                        element={<Healthplantype />}
                      ></Route>

                      <Route
                        path="healthmaritalstatus"
                        element={<Healthmaritalstatus />}
                      ></Route>

                      <Route
                        path="healthnationality"
                        element={<Healthnationality />}
                      ></Route>

                      <Route
                        path="healthnomineerelations"
                        element={<Healthnomineerelations />}
                      ></Route>

                      <Route
                        path="healthbusinesstype"
                        element={<Healthbusinesstype />}
                      ></Route>

                      <Route
                        path="healthclienttypes"
                        element={<Healthclienttypes />}
                      ></Route>

                      <Route
                        path="healthexternalsystem"
                        element={<Healthexternalsystem />}
                      ></Route>

                      <Route
                        path="Healthrelationcodes"
                        element={<Healthrelationcodes />}
                      ></Route>

                      <Route
                        path="healthsiaddons"
                        element={<Healthsiaddons />}
                      ></Route>

                      <Route
                        path="irdaproductname"
                        element={<Irdaproductname />}
                      ></Route>

                      <Route
                        path="healthreliancepins"
                        element={<Healthreliancepins />}
                      ></Route>

                      <Route
                        path="godigithealthpinmaster"
                        element={<Godigithealthpinmaster />}
                      ></Route>

                      <Route path="cposp" element={<PossscOne />}></Route>

                      <Route path="ipospv" element={<PossscOnep />}></Route>

                      <Route path="dposp" element={<PosscTwo />}></Route>

                      <Route path="iposdp" element={<Possctwp />}></Route>

                      <Route path="markup" element={<PosscThree />}></Route>

                      <Route path="markv" element={<Posscthres />}></Route>

                      <Route path="pospcr" element={<PospE />}></Route>

                      <Route
                        path="premiumapprovalentry"
                        element={<Premiumapprovalentry />}
                      ></Route>

                      <Route
                        path="premiumregisterentry"
                        element={<PremiumRegisterEntry />}
                      ></Route>

                      <Route
                        path="premiumregisterverification"
                        element={<PremiumRegisterVerification />}
                      ></Route>

                      <Route
                        path="premiumregisterapproval"
                        element={<PremiumRegisterApproval />}
                      ></Route>

                      <Route
                        path="icicihealthpincodes"
                        element={<Icicihealthpincodes />}
                      ></Route>

                      <Route
                        path="icicipolicieskycpage"
                        element={<ICICIPoliciesKYCPage />}
                      ></Route>

                      <Route
                        path="iciciproposeiinfo"
                        element={<ICICIProposeiinfo />}
                      ></Route>

                      <Route
                        path="icicimemberinfo"
                        element={<ICICIMemberinfo />}
                      ></Route>

                      <Route
                        path="icicimedicals"
                        element={<ICICIMedicals />}
                      ></Route>

                      <Route
                        path="icicinomineedetails"
                        element={<ICICINomineeDetails />}
                      ></Route>

                      <Route
                        path="iciciaddons"
                        element={<ICICIAddons />}
                      ></Route>

                      <Route
                        path="iciciproposalsummary"
                        element={<ICICIProposalsummary />}
                      ></Route>

                      <Route
                        path="icicithankspage"
                        element={<ICICIThanksPage />}
                      ></Route>

                      <Route
                        path="requesttypemaster"
                        element={<Requesttypemaster />}
                      ></Route>

                      <Route
                        path="itsupporttickets"
                        element={<Itsupporttickets />}
                      ></Route>

                      <Route
                        path="itsupportticketscreate"
                        element={<Itsupportticketscreate />}
                      ></Route>

                      <Route
                        path="itsupportticketsverify"
                        element={<Itsupportticketsverify />}
                      ></Route>

                      <Route
                        path="codedeployment"
                        element={<Codedeployment />}
                      ></Route>

                      <Route
                        path="codeverfication"
                        element={<CodeDeployVerfication />}
                      ></Route>

                      <Route
                        path="empattandance"
                        element={<EmployeesAttendance />}
                      ></Route>

                      <Route
                        path="bqfileupload"
                        element={<BulkQuoteFileupload />}
                      ></Route>

                      <Route path="bulkquote" element={<BulkQuote />}></Route>

                      <Route
                        path="bqdetails"
                        element={<BulkQuoteDetails />}
                      ></Route>

                      <Route path="widgetdef" element={<ChartWidget />}></Route>

                      <Route
                        path="widgetdashboard"
                        element={<Widgetdashboard />}
                      ></Route>

                      <Route path="drilldown" element={<Drilldown />}></Route>

                      <Route
                        path="userwidgetactivitylog"
                        element={<Userwidgetactivitylog />}
                      ></Route>

                      <Route
                        path="widgetdefinition"
                        element={<Widgetdefinition />}
                      ></Route>

                      <Route
                        path="integrationlibrary"
                        element={<Integrationlibrary />}
                      ></Route>

                      <Route
                        path="integrationtypemasters"
                        element={<Integrationtypemasters />}
                      ></Route>

                      <Route
                        path="requestjson"
                        element={<Requestjson />}
                      ></Route>

                      <Route
                        path="responsejson"
                        element={<Responsejson />}
                      ></Route>

                      <Route
                        path="requeststatus"
                        element={<Requeststatus />}
                      ></Route>

                      <Route
                        path="authenticationmethod"
                        element={<Authenticationmethod />}
                      ></Route>

                      <Route
                        path="officeslist"
                        element={<Officeslist />}
                      ></Route>

                      <Route
                        path="countriesstatescity"
                        element={<Countriesstatescity />}
                      ></Route>
                      <Route
                        path="apnapolicysubscribe"
                        element={<Apnapolicysubscribe />}
                      ></Route>
                      <Route path="rulegroups" element={<Rulegroups />}></Route>
                      <Route path="rulesdef" element={<Rulesdef />}></Route>
                      <Route
                        path="actiontypes"
                        element={<Actiontypes />}
                      ></Route>
                      <Route
                        path="ruleactions"
                        element={<Ruleactions />}
                      ></Route>
                      <Route path="ruleflows" element={<Ruleflows />}></Route>
                      <Route
                        path="ruleflowsteps"
                        element={<Ruleflowsteps />}
                      ></Route>
                      <Route
                        path="apiendpoint"
                        element={<Apiendpoint />}
                      ></Route>
                      <Route
                        path="emailtemplates"
                        element={<Emailtemplates />}
                      ></Route>
                      <Route
                        path="smstemplates"
                        element={<Smstemplates />}
                      ></Route>
                      <Route
                        path="ruleexecutionhistory"
                        element={<Ruleexecutionhistory />}
                      ></Route>
                      <Route
                        path="actionexecutionhistory"
                        element={<Actionexecutionhistory />}
                      ></Route>
                      <Route
                        path="ruleconditions"
                        element={<Ruleconditions />}
                      ></Route>
                      <Route
                        path="externalencryptions"
                        element={<Externalencryptions />}
                      ></Route>
                      <Route
                        path="ruletesttable"
                        element={<Ruletesttable />}
                      ></Route>
                      <Route
                        path="checklistsmaster"
                        element={<Checklistsmaster />}
                      ></Route>
                      <Route
                        path="organizations"
                        element={<Organizations />}
                      ></Route>
                      <Route path="policy" element={<Policy />}></Route>
                      <Route path="member" element={<Member />}></Route>
                      <Route
                        path="accountdetails"
                        element={<Accountdetails />}
                      ></Route>
                      <Route path="ped" element={<Ped />}></Route>
                      <Route
                        path="leadopportunity"
                        element={<Leadopportunity />}
                      ></Route>
                      <Route path="address" element={<Address />}></Route>
                      <Route
                        path="transactionstable"
                        element={<Transactionstable />}
                      ></Route>
                      <Route path="events" element={<Events />}></Route>
                      <Route path="meetings" element={<Meetings />}></Route>
                      <Route path="attendees" element={<Attendees />}></Route>
                      <Route path="claims" element={<Claims />}></Route>
                      <Route path="termsheets" element={<Termsheets />}></Route>
                      <Route
                        path="coveragecategory"
                        element={<Coveragecategory />}
                      ></Route>
                      <Route path="coverages" element={<Coverages />}></Route>
                      <Route
                        path="termsheetcoverage"
                        element={<Termsheetcoverage />}
                      ></Route>
                      <Route path="contact" element={<Contact />}></Route>
                      <Route path="hospital" element={<Hospital />}></Route>
                      <Route path="bill" element={<Bill />}></Route>
                      <Route path="leadstages" element={<Leadstages />}></Route>

                      <Route
                        path="dummyexample"
                        element={<Dummyexample />}
                      ></Route>
                      <Route path="testtable" element={<Testtable />}></Route>

                      <Route
                        path="abhadetails"
                        element={<Abhadetails />}
                      ></Route>
                      <Route
                        path="itprojectstable"
                        element={<Itprojectstable />}
                      ></Route>
                      <Route
                        path="userstoriestable"
                        element={<Userstoriestable />}
                      ></Route>
                      <Route
                        path="ittaskstable"
                        element={<Ittaskstable />}
                      ></Route>
                      <Route
                        path="taskmovementhistorytable"
                        element={<Taskmovementhistorytable />}
                      ></Route>
                      <Route
                        path="checklistidtable"
                        element={<Checklistidtable />}
                      ></Route>
                      <Route path="tasknotes" element={<Tasknotes />}></Route>
                      <Route
                        path="tasktypemaster"
                        element={<Tasktypemaster />}
                      ></Route>
                      <Route
                        path="sampletesttable"
                        element={<Sampletesttable />}
                      ></Route>
                      <Route
                        path="testcasetypemaster"
                        element={<Testcasetypemaster />}
                      ></Route>
                      <Route
                        path="testcaseprioritymaster"
                        element={<Testcaseprioritymaster />}
                      ></Route>
                      <Route
                        path="testcasestatusmaster"
                        element={<Testcasestatusmaster />}
                      ></Route>
                      <Route
                        path="environmentmaster"
                        element={<Environmentmaster />}
                      ></Route>
                      <Route
                        path="ittaskstestcaseshistory"
                        element={<Ittaskstestcaseshistory />}
                      ></Route>
                      <Route path="yes_no" element={<Yes_no />}></Route>
                      <Route
                        path="chatbotconversations"
                        element={<Chatbotconversations />}
                      ></Route>
                      <Route
                        path="trigger_event_type_master"
                        element={<Trigger_event_type_master />}
                      ></Route>
                      <Route
                        path="attachmenttypemaster"
                        element={<Attachmenttypemaster />}
                      ></Route>
                      <Route
                        path="ittaskstestcasesattachments"
                        element={<Ittaskstestcasesattachments />}
                      ></Route>
                      <Route
                        path="table_rule_triggers"
                        element={<Table_rule_triggers />}
                      ></Route>
                      <Route
                        path="rule_execution_queue"
                        element={<Rule_execution_queue />}
                      ></Route>
                      <Route
                        path="table_metadata"
                        element={<Table_metadata />}
                      ></Route>
                      <Route
                        path="chatbotconfig"
                        element={<Chatbotconfig />}
                      ></Route>
                      <Route
                        path="ittaskstestcases"
                        element={<Ittaskstestcases />}
                      ></Route>
                      <Route
                        path="chatbotmessagetypemaster"
                        element={<Chatbotmessagetypemaster />}
                      ></Route>
                      <Route
                        path="conversations"
                        element={<Conversations />}
                      ></Route>
                      <Route
                        path="chatbotmessages"
                        element={<Chatbotmessages />}
                      ></Route>
                      <Route
                        path="chatbotactiontypemaster"
                        element={<Chatbotactiontypemaster />}
                      ></Route>
                      <Route
                        path="chatbotintents"
                        element={<Chatbotintents />}
                      ></Route>
                      <Route
                        path="chatbotuserfeedback"
                        element={<Chatbotuserfeedback />}
                      ></Route>
                      <Route
                        path="chatbotlearningsource"
                        element={<Chatbotlearningsource />}
                      ></Route>
                      <Route
                        path="chatbotlearning"
                        element={<Chatbotlearning />}
                      ></Route>
                      <Route
                        path="chatbotuserrights"
                        element={<Chatbotuserrights />}
                      ></Route>
                      <Route
                        path="hook_execution_log"
                        element={<Hook_execution_log />}
                      ></Route>
                      <Route
                        path="rule_trigger_config"
                        element={<Rule_trigger_config />}
                      ></Route>
                      <Route
                        path="permissiontypemaster"
                        element={<Permissiontypemaster />}
                      ></Route>
                      <Route
                        path="accessscopetypemaster"
                        element={<Accessscopetypemaster />}
                      ></Route>
                      <Route
                        path="statustypemaster"
                        element={<Statustypemaster />}
                      ></Route>
                      <Route
                        path="role_permissions"
                        element={<Role_permissions />}
                      ></Route>
                      <Route
                        path="permission_modules"
                        element={<Permission_modules />}
                      ></Route>
                      <Route path="user_roles" element={<User_roles />}></Route>
                      <Route
                        path="table_permissions"
                        element={<Table_permissions />}
                      ></Route>
                      <Route
                        path="rbac_audit_log"
                        element={<Rbac_audit_log />}
                      ></Route>
                      <Route
                        path="permission_resources"
                        element={<Permission_resources />}
                      ></Route>
                      <Route
                        path="usercontexttypemaster"
                        element={<Usercontexttypemaster />}
                      ></Route>
                      <Route
                        path="accessleveltypemaster"
                        element={<Accessleveltypemaster />}
                      ></Route>
                      <Route
                        path="user_contexts"
                        element={<User_contexts />}
                      ></Route>
                      <Route
                        path="permission_conditions"
                        element={<Permission_conditions />}
                      ></Route>
                      <Route
                        path="deploymentstatus"
                        element={<Deploymentstatus />}
                      ></Route>
                      <Route
                        path="cross_table_lookup_cache"
                        element={<Cross_table_lookup_cache />}
                      ></Route>
                      <Route
                        path="rule_execution_performance"
                        element={<Rule_execution_performance />}
                      ></Route>
                      <Route
                        path="parameter_mapping_templates"
                        element={<Parameter_mapping_templates />}
                      ></Route>
                      <Route
                        path="rule_execution_alerts"
                        element={<Rule_execution_alerts />}
                      ></Route>
                      <Route
                        path="universalsomporater"
                        element={<Universalsomporater />}
                      ></Route>
                      <Route
                        path="universalsompoaddonrater"
                        element={<Universalsompoaddonrater />}
                      ></Route>
                      <Route
                        path="charttypemaster"
                        element={<Charttypemaster />}
                      ></Route>
                      <Route
                        path="widgetslibrary"
                        element={<Widgetslibrary />}
                      ></Route>
                      <Route
                        path="widgetsrightstable"
                        element={<Widgetsrightstable />}
                      ></Route>
                      <Route
                        path="peddeclarationform"
                        element={<PedDeclarationForm />}
                      ></Route>
                      <Route
                        path="peddeclarationdetails"
                        element={<Peddeclarationdetails />}
                      ></Route>
                      <Route path="altertable" element={<Altertable />}></Route>
                      <Route
                        path="samplejsonrequest"
                        element={<SampleJSONrequest />}
                      />
                      <Route
                        path="integration_library"
                        element={<IntegrationLibrarynew />}
                      ></Route>
                      <Route path="testhigh" element={<Test />} />
                      <Route
                        path="motorquotes"
                        element={<Motorquotes />}
                      ></Route>
                      <Route
                        path="mproposelsummary"
                        element={<MProposelsummary />}
                      ></Route>
                      <Route
                        path="mcustomerdetails"
                        element={<McustomerDetails />}
                      />
                      <Route path="mquote" element={<MQuotes />}></Route>
                      <Route path="mvinfo" element={<MVechileInfo />} />
                      <Route
                        path="mpolicydownload"
                        element={<Mpolicydownload />}
                      ></Route>
                      <Route path="mckyc" element={<Mckyc />} />
                      {/* Abha routing */}
                      <Route path="abhalogin" element={<Abhalogin />}></Route>
                      <Route
                        path="consentcollectionaadhaar"
                        element={<ConsentCollectionAadhaar />}
                      ></Route>
                      <Route
                        path="aadhaarauthentication"
                        element={<AadharAuthentication />}
                      ></Route>
                      <Route
                        path="communicationdetails"
                        element={<CommunicationDetails />}
                      ></Route>
                      <Route
                        path="mobilenumberotp"
                        element={<Mobilenumberotp />}
                      ></Route>
                      <Route
                        path="mobileabhaprofile"
                        element={<Mobileabhaprofile />}
                      ></Route>
                      <Route
                        path="mobileAuthentication"
                        element={<MobileAuthentication />}
                      ></Route>
                      <Route
                        path="profileabhacollection"
                        element={<ProfileAbhaCollection />}
                      ></Route>
                      <Route
                        path="abhaaddresscreation"
                        element={<AbhaAddressCreation />}
                      ></Route>
                      <Route
                        path="abharegister"
                        element={<Abharegister />}
                      ></Route>
                      <Route
                        path="abhaprofile"
                        element={<ABHAProfile />}
                      ></Route>
                      <Route
                        path="abhaaddressverification"
                        element={<Abhaaddressverfication />}
                      ></Route>
                      <Route
                        path="abhaaddresschange"
                        element={<AbhaAddressChange />}
                      ></Route>
                      <Route
                        path="existingabha"
                        element={<ExistingAbha />}
                      ></Route>
                      <Route
                        path="updateprofile"
                        element={<UpdateProfile />}
                      ></Route>
                      <Route
                        path="kycreverification"
                        element={<KYCreverification />}
                      ></Route>
                      <Route path="rekyc" element={<Rekysuccuess />}></Route>
                      <Route
                        path="admindragdrop"
                        element={<AdminDragDrop />}
                      ></Route>
                      <Route path="pipelines" element={<Pipelines />}></Route>
                      <Route path="tasknotes" element={<Tasknotes />}></Route>
                      <Route path="Mobileotp" element={<MobileOtp />}></Route>
                      <Route
                        path="abhaverification"
                        element={<AbhaVerification />}
                      ></Route>
                      {/* Zuno Routing */}
                      <Route path="zunoquotes" element={<ZunoQuotes />}></Route>
                      <Route
                        path="zunopolicyformpage"
                        element={<Zunopolicyformpage />}
                      ></Route>
                      <Route
                        path="zunoKycpage"
                        element={<ZunoKycpage />}
                      ></Route>
                      <Route
                        path="zunoproposerinfo"
                        element={<ZunoProposerinfo />}
                      ></Route>
                      <Route
                        path="zunomemberinfo"
                        element={<ZunoMemberinfo />}
                      ></Route>
                      <Route
                        path="zunomedical"
                        element={<ZunoMedical />}
                      ></Route>
                      <Route path="zunoaddons" element={<ZunoAddons />}></Route>
                      <Route
                        path="ZunoNominee"
                        element={<ZunoNominee />}
                      ></Route>
                      <Route
                        path="zunoproposalsummary"
                        element={<ZunoProposalsummary />}
                      ></Route>
                      <Route
                        path="ZunoPolicydownload"
                        element={<ZunoPolicydownload />}
                      ></Route>
                      {/*end Zuno Routing */}
                      <Route
                        path="archivedragdata"
                        element={<ArchiveDragData />}
                      ></Route>
                      <Route path="company" element={<Company />}></Route>
                      <Route
                        path="stagingmemberstable"
                        element={<Stagingmemberstable />}
                      ></Route>
                      <Route
                        path="healthmemberdata"
                        element={<Healthmemberdata />}
                      ></Route>
                      <Route
                        path="healthmemberexport"
                        element={<HealthMemberExport />}
                      ></Route>
                      <Route
                        path="employeestatusmaster"
                        element={<Employeestatusmaster />}
                      ></Route>
                      <Route
                        path="companyhasemployees"
                        element={<Companyhasemployees />}
                      ></Route>
                      <Route
                        path="employeefamilymanagement"
                        element={<EmployeeFamilyManagement />}
                      ></Route>
                      <Route
                        path="industrytypemaster"
                        element={<Industrytypemaster />}
                      ></Route>
                      <Route
                        path="bulkimportstatusmaster"
                        element={<Bulkimportstatusmaster />}
                      ></Route>
                      <Route
                        path="bulkimportoperationtypemaster"
                        element={<Bulkimportoperationtypemaster />}
                      ></Route>
                      <Route
                        path="bulkimportoperationstatusmaster"
                        element={<Bulkimportoperationstatusmaster />}
                      ></Route>
                      <Route
                        path="bulkimportruletypemaster"
                        element={<Bulkimportruletypemaster />}
                      ></Route>
                      <Route
                        path="bulkimportprioritymaster"
                        element={<Bulkimportprioritymaster />}
                      ></Route>
                      <Route
                        path="import_sessions"
                        element={<Import_sessions />}
                      ></Route>
                      <Route
                        path="import_field_mappings"
                        element={<Import_field_mappings />}
                      ></Route>
                      <Route
                        path="import_process_logs"
                        element={<Import_process_logs />}
                      ></Route>
                      <Route
                        path="import_validation_rules"
                        element={<Import_validation_rules />}
                      ></Route>
                      <Route
                        path="import_templates"
                        element={<Import_templates />}
                      ></Route>
                      <Route
                        path="import_queue"
                        element={<Import_queue />}
                      ></Route>
                      <Route path="bulkImport" element={<BulkImport />}></Route>
                      <Route
                        path="bulkimportwizard"
                        element={<BulkImportWizard />}
                      ></Route>
                      <Route
                        path="fieldmappingstep"
                        element={<FieldMappingStep />}
                      ></Route>
                      <Route
                        path="fileuploadstep"
                        element={<FileUploadStep />}
                      ></Route>
                      <Route
                        path="processingstep"
                        element={<ProcessingStep />}
                      ></Route>
                      <Route
                        path="resultsstep"
                        element={<ResultsStep />}
                      ></Route>
                      <Route
                        path="tableselectionstep"
                        element={<TableSelectionStep />}
                      ></Route>
                      <Route
                        path="validationstep"
                        element={<ValidationStep />}
                      ></Route>
                      <Route
                        path="tw_uat_master"
                        element={<Tw_uat_master />}
                      ></Route>
                      <Route
                        path="tw_rto_master"
                        element={<Tw_rto_master />}
                      ></Route>
                      <Route
                        path="pincodemaster"
                        element={<Pincodemaster />}
                      ></Route>
                      <Route
                        path="tatainsurancemaster"
                        element={<Tatainsurancemaster />}
                      ></Route>
                      <Route
                        path="tata_mmv_master"
                        element={<Tata_mmv_master />}
                      ></Route>
                      <Route
                        path="tata_finance_master"
                        element={<Tata_finance_master />}
                      ></Route>
                      <Route
                        path="generatebulkquote"
                        element={<Generatebulkquote />}
                      ></Route>
                      <Route
                        path="generatesamplepage"
                        element={<Generatesamplepage />}
                      ></Route>
                      <Route
                        path="universalsompoproducts"
                        element={<Universalsompoproducts />}
                      ></Route>
                      <Route
                        path="universalsompoaddons"
                        element={<Universalsompoaddons />}
                      ></Route>
                      <Route
                        path="bulkquoteaddonrequest"
                        element={<Bulkquoteaddonrequest />}
                      ></Route>
                      <Route
                        path="bulkquotebasepremiumrequest"
                        element={<Bulkquotebasepremiumrequest />}
                      ></Route>
                      <Route
                        path="universalpincodes"
                        element={<Universalpincodes />}
                      ></Route>
                      <Route
                        path="bulkquotesummary"
                        element={<Bulkquotesummary />}
                      ></Route>
                      <Route
                        path="zunothankspage"
                        element={<Zunothankspage />}
                      ></Route>
                      <Route
                        path="zunokycresponse"
                        element={<ZunoKycresponse />}
                      ></Route>
                      <Route
                        path="bulkquoterequest"
                        element={<Bulkquoterequest />}
                      ></Route>
                      <Route
                        path="bulkquoteaddonsummary"
                        element={<Bulkquoteaddonsummary />}
                      ></Route>
                      <Route
                        path="motorproducts"
                        element={<Motorproducts />}
                      ></Route>
                      <Route
                        path="motoraddonstable"
                        element={<Motoraddonstable />}
                      ></Route>
                      <Route path="magmarater" element={<Magmarater />}></Route>
                      <Route
                        path="mquotesaddons"
                        element={<MQuotesaddons />}
                      ></Route>
                      <Route
                        path="magmapincodes"
                        element={<Magmapincodes />}
                      ></Route>
                      <Route
                        path="altertabletesting"
                        element={<Altertabletesting />}
                      ></Route>
                      <Route
                        path="bulkquoteefd"
                        element={<Bulkquoteefd />}
                      ></Route>
                      <Route path="deals" element={<Deals />}></Route>
                      {/* <Route path='dummytable' element={<Dummytable />}></Route> */}
                      {/* <Route path='testtableoone' element={<Testtableoone />}></Route> */}
                      <Route
                        path="dailystatusreport"
                        element={<Dailystatusreport />}
                      ></Route>
                      <Route
                        path="testtabletwo"
                        element={<Testtabletwo />}
                      ></Route>
                      <Route
                        path="widgetinstancesmanager"
                        element={<Widgetinstancesmanager />}
                      ></Route>
                      <Route
                        path="page_layouts"
                        element={<Page_layouts />}
                      ></Route>
                      <Route
                        path="layout_rows"
                        element={<Layout_rows />}
                      ></Route>
                      <Route
                        path="layout_cells"
                        element={<Layout_cells />}
                      ></Route>
                      <Route
                        path="widget_instances"
                        element={<Widget_instances />}
                      ></Route>
                      <Route
                        path="widget_library_categories"
                        element={<Widget_library_categories_NEW />}
                      ></Route>
                      <Route
                        path="table_form_mapping"
                        element={<Table_form_mapping_NEW />}
                      ></Route>
                      <Route
                        path="widget_types"
                        element={<Widget_types_NEW />}
                      ></Route>
                      <Route
                        path="widget_event_bindings"
                        element={<Widget_event_bindings_NEW />}
                      ></Route>
                      <Route
                        path="form_field_validations"
                        element={<Form_field_validations_NEW />}
                      ></Route>
                      <Route
                        path="user_preferences"
                        element={<User_preferences_NEW />}
                      ></Route>
                      <Route
                        path="user_dashboard_configs"
                        element={<User_dashboard_configs_NEW />}
                      ></Route>
                      <Route
                        path="resource_permissions"
                        element={<Resource_permissions_NEW />}
                      ></Route>
                      <Route path="audit_logs" element={<Audit_logs />}></Route>
                      <Route
                        path="audit_log_config"
                        element={<Audit_log_config />}
                      ></Route>
                      <Route
                        path="user_feature_flags"
                        element={<User_feature_flags_NEW />}
                      ></Route>
                      <Route
                        path="widgetinstancesmanager"
                        element={<Widgetinstancesmanager />}
                      ></Route>
                      <Route
                        path="batchmigration"
                        element={<BatchMigration />}
                      ></Route>
                      <Route
                        path="widgeteventcontext"
                        element={<WidgetEventContext />}
                      ></Route>
                      {/* Auto-generated routes disabled — these render without required props */}
                      {/* <Route path="widgetpagerenderer" element={<WidgetPageRenderer/>}></Route> */}
                      {/* <Route path="widgetregistry" element={<WidgetRegistry/>}></Route> */}
                      {/* <Route path="widgetrenderer" element={<WidgetRenderer/>}></Route> */}
                      <Route
                        path="dynamicformadapter"
                        element={<DynamicFormAdapter />}
                      ></Route>
                      <Route
                        path="highchartsadapter"
                        element={<HighchartsAdapter />}
                      ></Route>
                      <Route
                        path="kpicardadapter"
                        element={<KPICardAdapter />}
                      ></Route>
                      <Route
                        path="primereacttableadapter"
                        element={<PrimeReactTableAdapter />}
                      ></Route>
                      <Route
                        path="reactdatatableadapter"
                        element={<ReactDataTableAdapter />}
                      ></Route>
                      <Route
                        path="searchfilteradapter"
                        element={<SearchFilterAdapter />}
                      ></Route>
                      <Route
                        path="statichtmladapter"
                        element={<StaticHtmlAdapter />}
                      ></Route>
                      <Route
                        path="widgeterrorboundary"
                        element={<WidgetErrorBoundary />}
                      ></Route>
                      <Route
                        path="widgetloader"
                        element={<WidgetLoader />}
                      ></Route>
                      <Route
                        path="columnconfigeditor"
                        element={<ColumnConfigEditor />}
                      ></Route>
                      <Route
                        path="dashboardbuilder"
                        element={<DashboardBuilder />}
                      ></Route>
                      <Route
                        path="formconfigeditor"
                        element={<FormConfigEditor />}
                      ></Route>
                      <Route
                        path="layouteditor"
                        element={<LayoutEditor />}
                      ></Route>
                      <Route
                        path="layoutpreview"
                        element={<LayoutPreview />}
                      ></Route>
                      <Route
                        path="widgetinstanceeditor"
                        element={<WidgetInstanceEditor />}
                      ></Route>
                      <Route
                        path="data_access_rules"
                        element={<Data_access_rules />}
                      ></Route>
                      <Route
                        path="field_access_rules"
                        element={<Field_access_rules />}
                      ></Route>
                      <Route
                        path="hierarchy_cache"
                        element={<Hierarchy_cache />}
                      ></Route>
                      <Route
                        path="dealconversations"
                        element={<DealConversations />}
                      ></Route>
                      <Route path="events" element={<Events />}></Route>
                      <Route
                        path="eventactions"
                        element={<Eventactions />}
                      ></Route>
                      <Route
                        path="event_conditions"
                        element={<Event_conditions />}
                      ></Route>
                      <Route
                        path="event_queue"
                        element={<Event_queue />}
                      ></Route>
                      <Route
                        path="eventtypemaster"
                        element={<Eventtypemaster />}
                      ></Route>
                      <Route
                        path="eventactiontypemaster"
                        element={<Eventactiontypemaster />}
                      ></Route>
                      <Route path="testevents" element={<Testevents />}></Route>
                      <Route path="dealnotes" element={<Dealmnotes />}></Route>
                      <Route
                        path="deploymentrequests"
                        element={<Deploymentrequests />}
                      ></Route>
                      <Route
                        path="deploymentfiles"
                        element={<Deploymentfiles />}
                      ></Route>
                      <Route
                        path="deploymentdbqueries"
                        element={<Deploymentdbqueries />}
                      ></Route>
                      <Route
                        path="deploymentstatusmaster"
                        element={<Deploymentstatusmaster />}
                      ></Route>
                      <Route
                        path="deploymentapprovals"
                        element={<Deploymentapprovals />}
                      ></Route>
                      <Route
                        path="deploymentrollback"
                        element={<Deploymentrollback />}
                      ></Route>
                      <Route
                        path="deploymentpackages"
                        element={<Deploymentpackages />}
                      ></Route>
                      <Route
                        path="deploymentactiontypemaster"
                        element={<Deploymentactiontypemaster />}
                      ></Route>
                      <Route
                        path="itdashboard"
                        element={<ITDashboard />}
                      ></Route>
                      <Route
                        path="ithomedashboard"
                        element={<ITHomeDashboard />}
                      ></Route>
                      <Route
                        path="employeetasksummary"
                        element={<Employeetasksummary />}
                      ></Route>
                      <Route
                        path="deploymentrequestpage"
                        element={<DeploymentRequestpage />}
                      ></Route>
                      <Route
                        path="deploymentdashboard"
                        element={<DeploymentDashboard />}
                      ></Route>
                      <Route
                        path="repochanges"
                        element={<RepoChanges />}
                      ></Route>
                      <Route
                        path="deploymentexecution"
                        element={<DeploymentExecutionPage />}
                      ></Route>
                      <Route
                        path="linkedrequests"
                        element={<LinkedRequestsView />}
                      ></Route>
                      <Route
                        path="deploymentconfig"
                        element={<DeploymentConfig />}
                      ></Route>
                      <Route
                        path="crossteamcheck"
                        element={<CrossTeamCheck />}
                      ></Route>
                      <Route
                        path="emailstatusmaster"
                        element={<Emailstatusmaster />}
                      ></Route>
                      <Route
                        path="triggermaster"
                        element={<Triggermaster />}
                      ></Route>
                      <Route path="tv_tokens" element={<Tv_tokens />}></Route>
                      <Route
                        path="headersmaster"
                        element={<Headersmaster />}
                      ></Route>
                      <Route
                        path="taskpenalitypoints"
                        element={<Taskpenalitypoints />}
                      ></Route>
                      {/* <-- replaceRoute --> } */}
                    </Routes>
                  </div>
                </header>
              </main>

              <footer className="footer-admin mt-auto footer-light">
                <p> All &#169; Right's Reserved by Apnapolicy.</p> &nbsp;
                <a
                  href={configData.api_url + "uploads/disclaimer.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Disclaimer
                </a>
                &nbsp;
                <a
                  href={configData.api_url + "uploads/privacy-policy.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                &nbsp;
                <a
                  href={configData.api_url + "uploads/tou.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Use
                </a>
                &nbsp;
              </footer>
            </div>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}
